// ==================== Start Product Slider ====================
function ThumbnailPlugin(main) {
  return (slider) => {
    function removeActive() {
      slider.slides.forEach((slide) => slide.classList.remove("is-active"));
    }

    function addActive(idx) {
      slider.slides[idx].classList.add("is-active");
    }

    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener("click", () => {
          main.moveToIdx(idx);
        });
      });
    }

    slider.on("created", () => {
      addActive(main.track.details.rel);
      addClickEvents();

      main.on("animationStarted", (mainInstance) => {
        removeActive();
        const next = mainInstance.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));

        
      });
    });
  };
}


const createProductSlider = function () {
  const gallery = document.querySelector(".product-media__gallery--slider");
  const thumbs = document.querySelector("#product-thumbs-slider");
  if (!gallery) return;

  const enableSlider = gallery.dataset.enableSlider === "true";
  const isDesktop = window.matchMedia("(min-width: 750px)").matches;

  // === Main slider ===
  const mainSlider = new KeenSlider(
    gallery,
    {
      slides: { perView: 1, spacing: 0, origin: "center" },
      loop: false,
      rubberband: false,
      renderMode: "precision",
      breakpoints: enableSlider
        ? {
            "(min-width: 750px)": {
              slides: { perView: 1, spacing: 0, origin: "center" },
            },
          }
        : { "(min-width: 750px)": { disabled: true } },
      slideChanged() {
        sliderDotsAnimation();
      },
      updated() {
        sliderDotsAnimation();
      },
      created(slider) {
      gallery.classList.add("is-initialized")
      },
    },
    [navigation]
  );

  gallery._keenSliderInstance = mainSlider;

  // === Sync heights for thumbs wrapper ===
  const mainWrapper = document.querySelector(".product-media__gallery--slider");
  const thumbsWrapper = document.querySelector(".product-thumbs-wrapper");

  if (mainWrapper && thumbsWrapper && isDesktop) {
    const syncHeights = () => {
      thumbsWrapper.style.height = mainWrapper.offsetHeight + "px";
      // Reveal thumbs only after height is applied
      thumbsWrapper.classList.add("is-synced")
    };

    // Run once immediately
    syncHeights();
    
    window.addEventListener("resize", syncHeights);
    window.addEventListener("load", syncHeights);
  }


  // === Init thumbnails only on desktop ===
  if (enableSlider && thumbs && isDesktop) {
   const thumbsSlider = new KeenSlider(
thumbs,
  {
    vertical: true,
    mode: "snap",
    rubberband: false,
    renderMode: "precision",
    drag: false,
    slides: {
      perView: "auto",
      spacing: 8,
    },
    breakpoints: {
      "(max-width: 749px)": {
        disabled: true,
      },
    },
    created(slider) {
      thumbs.classList.add("is-initialized")
    },
  },
  [ThumbnailPlugin(mainSlider)]
);
  thumbs.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })
thumbs.addEventListener("touchmove", (e) => e.preventDefault(), { passive: false })

    // Arrows for thumbs
    const upArrow = document.querySelector(".thumbs-arrow--up");
    const downArrow = document.querySelector(".thumbs-arrow--down");

    if (upArrow && downArrow) {
      upArrow.addEventListener("click", () => {
        thumbsSlider.moveToIdx(Math.max(thumbsSlider.track.details.rel - 1, 0));
      });
      downArrow.addEventListener("click", () => {
        thumbsSlider.moveToIdx(
          Math.min(
            thumbsSlider.track.details.rel + 1,
            thumbsSlider.track.details.slides.length - 1
          )
        );
      });
    }
  }

  // === Keep Keen in sync with layout changes ===
  const mediaOuter = document.querySelector(".product-media__outer");
  if (mediaOuter && "ResizeObserver" in window) {
    new ResizeObserver(() => mainSlider.update()).observe(mediaOuter);
  }
  window.addEventListener("load", () => mainSlider.update(), { once: true });
  window.addEventListener("resize", () => {
    clearTimeout(window.__ks);
    window.__ks = setTimeout(() => mainSlider.update(), 120);
  });

  // === Main arrows ===
  const prevBtn = document.querySelector(".slider-arrow--left");
  const nextBtn = document.querySelector(".slider-arrow--right");
  if (isDesktop && prevBtn && nextBtn) {
    prevBtn.addEventListener("click", () => mainSlider.prev());
    nextBtn.addEventListener("click", () => mainSlider.next());
  } else {
    if (prevBtn) prevBtn.style.display = "none";
    if (nextBtn) nextBtn.style.display = "none";
  }

  document.dispatchEvent(
    new CustomEvent("product:slider-ready", {
      detail: {
        gallery,
        slider: mainSlider,
      },
    })
  );
};

document.addEventListener("DOMContentLoaded", createProductSlider);

// ==================== End Product Slider ====================

// ==================== Product info sticky offset ====================
// Exposes the details block's height to CSS, which pins it with native sticky
// at min(header offset, viewport height - block height): short blocks stick
// below the header, tall ones scroll until their bottom reaches the viewport.
(function initProductInfoStickyOffset() {
  const init = () => {
    const productInfo = document.querySelector(
      "#main-product .product-info__inner:not(.pack)"
    );
    if (!productInfo || !("ResizeObserver" in window)) return;

    new ResizeObserver(() => {
      productInfo.style.setProperty(
        "--product-info-height",
        `${productInfo.offsetHeight}px`
      );
    }).observe(productInfo);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

// ==================== End Product info sticky offset ====================

const influencerVideoTest = (() => {
  function getMainProductRoot() {
    return document.getElementById("main-product");
  }

  function getConfig() {
    const configEl = document.getElementById("influencer-video-test-config");
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      console.error("Failed to parse influencer video test config", error);
      return null;
    }
  }

  function getGallery() {
    return document.querySelector(".product-media__gallery--slider");
  }

  function getSlider() {
    return getGallery()?._keenSliderInstance || null;
  }

  function isMobileViewport() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function hasInjectedSlide(gallery = getGallery()) {
    return !!gallery?.querySelector("[data-influencer-video-slide]");
  }

 function syncMobileBadgeVisibility() {
  const root = getMainProductRoot();
  const slider = getSlider();
  const gallery = getGallery();

  if (!root) return;

  const isInfluencerSlideActive =
    isMobileViewport() &&
    !!slider &&
    !!gallery &&
    hasInjectedSlide(gallery) &&
    (slider.track?.details?.rel ?? -1) ===
      gallery.querySelectorAll(".keen-slider__slide").length - 1;

  root.classList.toggle("influencer-video-slide-active", isInfluencerSlideActive);
}

  function updateAudioButton(button, video) {
    const soundOn = !video.muted;
    button.dataset.muted = video.muted ? "true" : "false";
    button.setAttribute("aria-pressed", soundOn ? "true" : "false");
    button.setAttribute("aria-label", soundOn ? "Turn sound off" : "Turn sound on");
  }

  function bindAudioToggle(slide) {
    const video = slide.querySelector(".product-media__video--influencer");
    const button = slide.querySelector("[data-influencer-video-audio-toggle]");
    if (!video || !button) return;

    updateAudioButton(button, video);

    button.addEventListener("click", () => {
      video.muted = !video.muted;
      updateAudioButton(button, video);
      video.play().catch(() => {});
    });
  }

  function loadAndPlayVideo(video) {
    if (!video) return;

    try {
      video.load();
    } catch (error) {
      console.error("Failed to load influencer video", error);
    }

    const playVideo = () => {
      video.play().catch((error) => {
        console.error("Failed to autoplay influencer video", error);
      });
    };

    if (video.readyState >= 2) {
      playVideo();
      return;
    }

    video.addEventListener("loadeddata", playVideo, { once: true });
    video.addEventListener(
  "error",
  () => {
    console.error(
      "Influencer video failed to load",
      video.currentSrc || video.querySelector("source")?.src || ""
    );
  },
  { once: true }
);
  }

  function injectSlide() {
    const gallery = getGallery();
    const slider = getSlider();
    const template = document.getElementById("influencer-video-slide-template");

    if (!gallery || !slider || !template || hasInjectedSlide(gallery)) return;

    const slide = template.content.firstElementChild.cloneNode(true);
    gallery.appendChild(slide);
    bindAudioToggle(slide);
    slider.update();
    syncMobileBadgeVisibility();

    loadAndPlayVideo(slide.querySelector("video"));
    window.dispatchEvent(new CustomEvent("unbound:influencer-video-slide-inserted"));
  }

  function bindLastImageLoadFallback(gallery, config) {
    if (!config?.triggerOnLastImageLoad || gallery.dataset.influencerVideoLoadBound === "true") return;

    gallery.dataset.influencerVideoLoadBound = "true";
    const lastOriginalSlide = gallery.querySelector(".keen-slider__slide:last-child");
    const lastImage = lastOriginalSlide?.querySelector("img");

    if (!lastImage) return;

    const tryInject = () => {
      if (!isMobileViewport()) return;
      injectSlide();
    };

    if (lastImage.complete && lastImage.naturalWidth > 0) {
      tryInject();
      return;
    }

    lastImage.addEventListener("load", tryInject, { once: true });
  }

  function bindGallery() {
    const gallery = getGallery();
    const slider = getSlider();
    const config = getConfig();

    if (!gallery || !slider || !config?.enabled) return;

    const originalSlideCount = gallery.querySelectorAll(".keen-slider__slide").length;

    if (gallery.dataset.influencerVideoBound !== "true") {
      gallery.dataset.influencerVideoBound = "true";

      slider.on("slideChanged", (instance) => {
        syncMobileBadgeVisibility();

        if (!isMobileViewport() || hasInjectedSlide(gallery)) return;

        const activeIndex = instance.track?.details?.rel ?? 0;
        if (activeIndex >= originalSlideCount - 1) {
          injectSlide();
        }
      });
    }

    bindLastImageLoadFallback(gallery, config);
    syncMobileBadgeVisibility();

    if (isMobileViewport()) {
      const activeIndex = slider.track?.details?.rel ?? 0;
      if (activeIndex >= originalSlideCount - 1) {
        injectSlide();
      } else {
        syncMobileBadgeVisibility();
      }
      return;
    }

    injectSlide();
  }

  function init() {
    if (!getConfig()?.enabled) return;
    bindGallery();
  }

  return {
    init,
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  influencerVideoTest.init();
});

document.addEventListener("product:slider-ready", () => {
  influencerVideoTest.init();
});

window.addEventListener("resize", () => {
  influencerVideoTest.init();
});

// ==================== Start slider dots animation ====================
// Start helper functions
const createDotBackground = function () {
  const dots = document.querySelector(".product-media__gallery .dots");
  if (!dots) return;
  let dotBackground = dots.querySelector(".dot__background");
  if (dotBackground) return;
  dotBackground = document.createElement("span");
  dotBackground.classList.add("dot__background");
  dots.insertAdjacentElement("beforeend", dotBackground);
};

const updateDotBackground = function () {
  const dots = document.querySelector(".product-media__gallery .dots");
  if (!dots) return;
  const dotChildren = dots.querySelectorAll(".dot");
  const dotBackground = dots.querySelector(".dot__background");
  if (!dotBackground || dotChildren.length < 1) return;

  dotChildren.forEach((dot) => {
    if (dot.classList.contains("dot--active")) {
      dotBackground.style.width = `${parseInt(getComputedStyle(dot).width)}px`;
      dotBackground.style.left = `${dot.offsetLeft}px`;
    }
  });

  if (!dotBackground.classList.contains("animate")) {
    setTimeout(() => {
      dotBackground.classList.add("animate");
    }, 300);
  }
};
// End helper functions

const sliderDotsAnimation = function () {
  // 1. Create dotBackground element
  createDotBackground();

  // 2. Update dotBackground
  updateDotBackground();
};

document.addEventListener("DOMContentLoaded", sliderDotsAnimation);
// ==================== End slider dots animation ====================

function stripSavingsLabelDecimals(value) {
  return String(value ?? "").replace(/([.,]\d{1,2})(?=$|[^0-9])/g, "");
}

// Afterpay instalments must sum back to the displayed total, so keep the cents
// (a $270 pack is 4 x $67.50, not 4 x $68). Whole amounts stay unchanged.
function formatInstalment(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return "";
  return value.toFixed(2).replace(/\.00$/, "");
}

function getActiveCurrencyPrefix() {
  const activeCurrency = Shopify?.currency?.active;
  if (activeCurrency === "CAD") return "C";
  if (activeCurrency === "AUD") return "A";
  return "";
}

function applyActiveCurrencyPrefixToText(value) {
  const prefix = getActiveCurrencyPrefix();
  const text = String(value ?? "");

  if (!prefix) return text;

  return text.replace(/(^|[^A-Za-z])\$/g, (match, before) => `${before}${prefix}$`);
}

function getActiveMoneyPrefix(fallbackValue) {
  const prefix = getActiveCurrencyPrefix();
  if (prefix) return `${prefix}$`;
  return String(fallbackValue ?? "").replace(/[0-9.,\s]/g, "");
}

function getOrCreatePdpSaveBadges() {
  const containers = document.querySelectorAll(
    ".product-info-above-description-desktop .product-labels, .product-info-above-description-mobile .product-labels"
  );

  return Array.from(containers).map((container) => {
    let badge = container.querySelector("#pdp-save-badge");

    if (!badge) {
      badge = document.createElement("span");
      badge.className = "product-price__saving-label";
      badge.id = "pdp-save-badge";
      container.appendChild(badge);
    }

    return badge;
  });
}

function showPdpSaveBadge(saveAmount) {
  getOrCreatePdpSaveBadges().forEach((badge) => {
    const formattedSaveAmount =
      typeof formatVariantMoney === "function"
        ? formatVariantMoney(saveAmount)
        : "$" + saveAmount / 100;

    badge.textContent = "Save " + stripSavingsLabelDecimals(applyActiveCurrencyPrefixToText(formattedSaveAmount));
    badge.style.display = "";
  });

  syncProductLabelSavingsVisibility();
}

function hidePdpSaveBadge() {
  document.querySelectorAll("#pdp-save-badge").forEach((badge) => {
    badge.textContent = "";
    badge.style.display = "none";
  });

  syncProductLabelSavingsVisibility();
}

function isPackOfferPdpBadgeText(value) {
  return /^\d+\s+FOR\b/i.test(String(value ?? "").trim());
}

function syncProductLabelSavingsVisibility() {
  const labelContainers = document.querySelectorAll(".product-labels");

  labelContainers.forEach((container) => {
    const packSavingsBadge = container.querySelector(".singles-and-packs__savings");
    if (!packSavingsBadge) return;

    const pdpSaveBadgeText = container.querySelector("#pdp-save-badge")?.textContent?.trim() || "";
    const hasPackSavingsText = Boolean(packSavingsBadge.textContent?.trim());

    packSavingsBadge.style.display =
      isPackOfferPdpBadgeText(pdpSaveBadgeText) || !hasPackSavingsText ? "none" : "";
  });
}

function showPackPillBadgeIfAvailable() {
  // Don't show on pack builder pages — only on single product pages with a pack upsell
  if (document.querySelector(".singles-and-packs__btn[data-type='packs']") === null &&
      document.querySelector("bundle-builder.bundle-builder--pack") !== null) return false;
  const savings = document.querySelector(
    ".singles-and-packs__bundle-builder .bundle-builder__savings-message, .bundle-builder__savings-message"
  );
  if (!savings) return false;
  const threshold = savings.dataset.packThreshold?.trim();
  const upsellPrice = savings.dataset.upsellPrice?.trim();
  if (!threshold || !upsellPrice) return false;
  const bundleBuilder = savings.closest("bundle-builder");
  const currencyPrefix = bundleBuilder?.dataset?.currencyPrefix || "";
  const formattedPrice = upsellPrice.replace(/^(\$|€|£)/, `${currencyPrefix}$1`);
  getOrCreatePdpSaveBadges().forEach((badge) => {
    badge.textContent = `${threshold} FOR ${formattedPrice}`;
    badge.style.display = "";
  });

  syncProductLabelSavingsVisibility();
  return true;
}

function parseProductColorList(value) {
  return String(value || "")
    .split(",")
    .map((color) => color.trim().toLowerCase())
    .filter(Boolean);
}

function getLastChanceColors(scope = document) {
  const form = scope?.closest?.(".product-form")
    || scope?.querySelector?.(".product-form")
    || document.querySelector(".product-form");
  return parseProductColorList(form?.dataset?.lastChanceColors || "");
}

function getDiscontinuedColors() {
  if (typeof discontinued_colors === "undefined" || !discontinued_colors) return [];
  return parseProductColorList(discontinued_colors);
}

function isBisDisabledColor(color, scope = document) {
  const normalizedColor = String(color || "").trim().toLowerCase();
  if (!normalizedColor) return false;
  return getDiscontinuedColors().includes(normalizedColor)
    || getLastChanceColors(scope).includes(normalizedColor);
}

const OOS_SHADE_DESTINATION_CACHE = new Map();

window.unboundOosShadeLinkTest = {
  isEnabled() {
    return true;
  },
  enable() {},
  disable() {},
};

const PDP_PURCHASED_SIZES_COOKIE = "shopify_purchased_sizes";
const PDP_LAST_CART_SIZE_STORAGE_KEY = "unbound_last_cart_size_selection_v1";
let pdpLastCartSizePromise = null;

function normalizePdpSizeValue(value) {
  return String(value || "").trim().toLowerCase();
}

function parsePdpJsonCookie(name) {
  if (typeof getCookie !== "function") return null;

  const rawValue = getCookie(name);
  if (!rawValue) return null;

  try {
    return JSON.parse(decodeURIComponent(rawValue));
  } catch (error) {
    try {
      return JSON.parse(rawValue);
    } catch (fallbackError) {
      return null;
    }
  }
}

function readRawPdpCookie(name) {
  if (typeof getCookie !== "function") return "";

  const rawValue = getCookie(name);
  if (!rawValue) return "";

  try {
    return String(decodeURIComponent(rawValue) || "").trim();
  } catch (error) {
    return String(rawValue || "").trim();
  }
}

function getPurchasedSizeForProductHandle(productHandle) {
  const normalizedHandle = String(productHandle || "").trim().toLowerCase();
  if (!normalizedHandle) return "";

  const purchasedSizes = parsePdpJsonCookie(PDP_PURCHASED_SIZES_COOKIE);
  const entry = purchasedSizes?.[normalizedHandle];
  const sizeValue = typeof entry === "string" ? entry : entry?.size;

  if (sizeValue) {
    return String(sizeValue || "").trim();
  }

  const rawCookieValue = readRawPdpCookie(PDP_PURCHASED_SIZES_COOKIE);
  if (!rawCookieValue) return "";

  if (rawCookieValue.startsWith("{") || rawCookieValue.startsWith("[")) {
    return "";
  }

  return rawCookieValue;
}

function readLastCartSizeSelection() {
  try {
    const rawValue = window.sessionStorage.getItem(PDP_LAST_CART_SIZE_STORAGE_KEY);
    if (!rawValue) return "";

    const parsed = JSON.parse(rawValue);
    if (typeof parsed === "string") return parsed.trim();

    return String(parsed?.size || "").trim();
  } catch (error) {
    return "";
  }
}

function persistLastCartSizeSelection(size, source = "cart") {
  const normalizedSize = String(size || "").trim();
  if (!normalizedSize) return;

  try {
    window.sessionStorage.setItem(
      PDP_LAST_CART_SIZE_STORAGE_KEY,
      JSON.stringify({
        size: normalizedSize,
        source,
        updatedAt: Date.now(),
      })
    );
  } catch (error) {}
}

function clearLastCartSizeSelection() {
  try {
    window.sessionStorage.removeItem(PDP_LAST_CART_SIZE_STORAGE_KEY);
  } catch (error) {}
}

function extractSizeFromCartItem(item) {
  if (!item) return "";

  const optionEntries = Array.isArray(item.options_with_values)
    ? item.options_with_values
    : Array.isArray(item.options)
    ? item.options
    : [];

  const sizeOption = optionEntries.find((entry) => {
    const optionName = String(entry?.name || entry?.option || "").trim().toLowerCase();
    return optionName === "size";
  });

  if (sizeOption?.value) {
    return String(sizeOption.value).trim();
  }

  const variantTitleParts = String(item.variant_title || "")
    .split(" / ")
    .map((part) => part.trim())
    .filter(Boolean);

  if (Array.isArray(item.product_options) && item.product_options.length && variantTitleParts.length) {
    const sizeIndex = item.product_options.findIndex(
      (optionName) => String(optionName || "").trim().toLowerCase() === "size"
    );

    if (sizeIndex !== -1 && variantTitleParts[sizeIndex]) {
      return variantTitleParts[sizeIndex];
    }
  }

  if (variantTitleParts.length >= 2) {
    return variantTitleParts[1];
  }

  return "";
}

function fetchLastCartSizeSelection() {
  if (pdpLastCartSizePromise) return pdpLastCartSizePromise;

  const storedSize = readLastCartSizeSelection();

  pdpLastCartSizePromise = fetch("/cart.js", {
    credentials: "same-origin",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      return response.json();
    })
    .then((cart) => {
      const items = Array.isArray(cart?.items) ? cart.items : [];

       if (!items.length) {
        clearLastCartSizeSelection();
        return "";
      }

      // Prefer the explicit session value written on the latest add-to-cart.
      // Cart line ordering/merging is not a reliable proxy for "last chosen size".
      if (storedSize) {
        return storedSize;
      }

      for (let index = items.length - 1; index >= 0; index -= 1) {
        const size = extractSizeFromCartItem(items[index]);
        if (!size) continue;

        persistLastCartSizeSelection(size, "cart");
        return size;
      }

      return "";
    })
    .catch((error) => {
      console.error("Failed to resolve last cart size selection", error);
      return readLastCartSizeSelection();
    })
    .finally(() => {
      pdpLastCartSizePromise = null;
    });

  return pdpLastCartSizePromise;
}

// ==================== Start VariantRadios Class ====================
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.form = this.closest(".product-form");
    this._fetchCache = {};
    this._fetchController = null;
    this._debounceTimer = null;
    this.isBundleBuilder = this.form?.classList.contains(
      "product-form--bundle-builder"
    )
      ? true
      : false;
    this.bundleBuilderEl = this.isBundleBuilder
      ? this.closest(".bundle-builder")
      : "";
    this.multiAdd = this.form?.classList.contains("multi-add") ? true : false;
    this._lastOosShadeLinkVisibleKey = "";
    this._boundOosShadeLink = null;
    this._isApplyingPreferredSize = false;
    this._hasManualSizeSelection = false;
    this._preferredSizeSelection = "";
    this._preferredSizeSource = "";

    // Run savings label check on initial page load for the pre-selected variant.
    if (!this.isBundleBuilder) {
      requestAnimationFrame(() => {
        this.getVariantJSON();
        this.syncVariantOptionAvailability();
        this.getSelectedOptions();
        this.getSelectedVariant();
        this.updateSavingsLabel();
        this.updateOosShadeLink();
        this.initPreferredSizeSelection();
      });
    }
  }

  onVariantChange(e) {
    const changedOptionName = String(
      e?.target?.getAttribute("option") || ""
    ).trim().toLowerCase();

    if (changedOptionName === "size") {
      this.syncSizeLabelState();

      if (!this._isApplyingPreferredSize) {
        this._hasManualSizeSelection = true;
      }

      this.form?.classList.add("product-form--size-selected", "product-info-updated");
    }

    if (!this.multiAdd) {
      this.syncVariantOptionAvailability();

      if (
        (changedOptionName === "color" || changedOptionName === "colour")
        && !this._isApplyingPreferredSize
      ) {
        this.applyPreferredSizeSelection({ deferProductInfoUpdate: true });
      }
    }

    this.getSelectedOptions();
    this.getSelectedVariant();
    if (this.currentVariant && !this.multiAdd) {
      this.updateURL();
      this.updateFormID();
      this.updateProductInfo(e);
    }
    if (this.isBundleBuilder) {
      this.updateBundleBuilder();
    }

    if (this.multiAdd) {
      this.updateMultiAdd();
    }

    if (!this.multiAdd) {
      this.updateOosShadeLink();
    }
  }

  initPreferredSizeSelection() {
    const sizeInputs = this.getOptionInputs(["Size"]);
    if (this.isBundleBuilder || this.multiAdd || !sizeInputs.length) return;

    const storedCartSize = readLastCartSizeSelection();
    const purchasedSize = getPurchasedSizeForProductHandle(this.form?.dataset?.handle);

    if (storedCartSize) {
      this.setPreferredSizeSelection(storedCartSize, "cart");
      this.applyPreferredSizeSelection();
    } else if (purchasedSize) {
      this.setPreferredSizeSelection(purchasedSize, "purchase-history");
      this.applyPreferredSizeSelection();
    }

    fetchLastCartSizeSelection().then((cartSize) => {
      if (!cartSize) {
        if (this._preferredSizeSource === "cart") {
          const fallbackPurchasedSize = getPurchasedSizeForProductHandle(
            this.form?.dataset?.handle
          );

          if (fallbackPurchasedSize) {
            this.setPreferredSizeSelection(fallbackPurchasedSize, "purchase-history");
            this.applyPreferredSizeSelection();
          } else {
            this.setPreferredSizeSelection("", "");
          }
        }

        return;
      }
      if (this._hasManualSizeSelection) return;

      const currentSize = normalizePdpSizeValue(this._preferredSizeSelection);
      const nextSize = normalizePdpSizeValue(cartSize);
      if (this._preferredSizeSource === "cart" && currentSize === nextSize) return;

      this.setPreferredSizeSelection(cartSize, "cart");
      this.applyPreferredSizeSelection();
    });
  }

  setPreferredSizeSelection(size, source) {
    this._preferredSizeSelection = String(size || "").trim();
    this._preferredSizeSource = String(source || "").trim();

    if (!this.form) return;

    this.form.dataset.preferredSizeValue = this._preferredSizeSelection;
    this.form.dataset.preferredSizeSource = this._preferredSizeSource;
  }

  syncSizeLabelState(sizeInputs = this.getOptionInputs(["Size"])) {
    sizeInputs.forEach((input) => {
      const label = this.getInputLabel(input);
      if (!label) return;

      label.classList.toggle("active", input.checked);
    });
  }

  applyPreferredSizeSelection({ deferProductInfoUpdate = false } = {}) {
    if (this._isApplyingPreferredSize || this._hasManualSizeSelection) return false;

    const preferredSize = String(this._preferredSizeSelection || "").trim();
    if (!preferredSize) return false;

    const sizeInputs = this.getOptionInputs(["Size"]);
    if (!sizeInputs.length) return false;

    const targetInput = sizeInputs.find((input) => {
      if (input.hidden || input.classList.contains("disabled")) return false;

      return normalizePdpSizeValue(input.value) === normalizePdpSizeValue(preferredSize);
    });

    if (!targetInput) return false;

    if (targetInput.checked) {
      this.form?.classList.add("product-form--size-selected", "product-info-updated");
      this.syncSizeLabelState(sizeInputs);
      return true;
    }

    const previousVariantId = String(
      this.form?.querySelector('input[name="id"]')?.value || ""
    );

    this._isApplyingPreferredSize = true;
    setCheckedRadioInput(targetInput);
    this.form?.classList.add("product-form--size-selected", "product-info-updated");
    this.syncVariantOptionAvailability();
    this.syncSizeLabelState(sizeInputs);
    this.getSelectedOptions();
    this.getSelectedVariant();
    this._isApplyingPreferredSize = false;

    if (!this.currentVariant) return true;

    this.updateURL();
    this.updateFormID();
    this.updateSavingsLabel();

    if (!deferProductInfoUpdate && String(this.currentVariant.id) !== previousVariantId) {
      this.updateProductInfo({ target: targetInput });
    } else {
      this.updateOosShadeLink();
    }

    return true;
  }

  getSelectedOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".js-product-form-option")
    );
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return null;

      let selectedInput = inputs.find((radio) => radio.checked && !radio.hidden);

      if (!selectedInput) {
        selectedInput = inputs.find((radio) => !radio.hidden) || inputs[0];
        selectedInput.checked = true;
        selectedInput.setAttribute("checked", "");
      }

      inputs.forEach((radio) => {
        if (radio !== selectedInput) {
          radio.removeAttribute("checked");
        }
      });

      return selectedInput.value;
    });
  }

  getVariantJSON() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return option === this.options[index];
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  getOptionInputs(optionNames = []) {
    const normalizedNames = optionNames.map((name) => name.toLowerCase());

    return Array.from(
      this.querySelectorAll('.js-product-form-option input[type="radio"]')
    ).filter((input) =>
      normalizedNames.includes(
        (input.getAttribute("option") || "").trim().toLowerCase()
      )
    );
  }

  getInputLabel(input) {
    return input?.nextElementSibling?.tagName === "LABEL"
      ? input.nextElementSibling
      : null;
  }

  setInputVisibility(input, isVisible) {
    const label = this.getInputLabel(input);

    input.hidden = !isVisible;
    input.style.display = isVisible ? "" : "none";

    if (label) {
      label.hidden = !isVisible;
      label.style.display = isVisible ? "" : "none";
    }

    if (!isVisible) {
      input.checked = false;
      input.removeAttribute("checked");
      input.classList.remove("disabled");
    }
  }

  ensureVisibleSelection(inputs = []) {
    const visibleCheckedInput = inputs.find((input) => !input.hidden && input.checked);
    if (visibleCheckedInput) return;

    const fallbackInput = inputs.find((input) => !input.hidden);
    if (!fallbackInput) return;

    inputs.forEach((input) => {
      input.checked = input === fallbackInput;

      if (input === fallbackInput) {
        input.setAttribute("checked", "");
      } else {
        input.removeAttribute("checked");
      }
    });
  }

  syncVariantOptionAvailability() {
    const colorInputs = this.getOptionInputs(["Color", "Colour"]);
    const sizeInputs = this.getOptionInputs(["Size"]);
    const thirdInputs = this.getOptionInputs(["Inseam", "Length"]);

    if (!colorInputs.length || !sizeInputs.length) return;

    const selectedColorInput =
      colorInputs.find((input) => input.checked && !input.hidden) ||
      colorInputs.find((input) => !input.hidden);
    const selectedColor = selectedColorInput?.value;

    if (!selectedColor) return;

    const selectedColorVariants = this.getVariantJSON().filter(
      (variant) => variant.option1 === selectedColor
    );
    const validSizes = new Set(
      selectedColorVariants.map((variant) => variant.option2).filter(Boolean)
    );

    sizeInputs.forEach((input) => {
      const isVisible = validSizes.has(input.value);
      this.setInputVisibility(input, isVisible);

      if (isVisible) {
        const sizeVariants = selectedColorVariants.filter(
          (variant) => variant.option2 === input.value
        );
        const shouldDisable =
          !thirdInputs.length &&
          sizeVariants.length > 0 &&
          sizeVariants.every((variant) => !variant.available);

        input.classList.toggle("disabled", shouldDisable);
      }
    });

    this.ensureVisibleSelection(sizeInputs);

    const selectedSizeInput =
      sizeInputs.find((input) => input.checked && !input.hidden) ||
      sizeInputs.find((input) => !input.hidden);
    const selectedSize = selectedSizeInput?.value;

    if (!thirdInputs.length || !selectedSize) return;

    const selectedSizeVariants = selectedColorVariants.filter(
      (variant) => variant.option2 === selectedSize
    );
    const validThirdOptions = new Set(
      selectedSizeVariants.map((variant) => variant.option3).filter(Boolean)
    );

    thirdInputs.forEach((input) => {
      const isVisible = validThirdOptions.has(input.value);
      this.setInputVisibility(input, isVisible);

      if (isVisible) {
        const thirdVariants = selectedSizeVariants.filter(
          (variant) => variant.option3 === input.value
        );
        const shouldDisable =
          thirdVariants.length > 0 &&
          thirdVariants.every((variant) => !variant.available);

        input.classList.toggle("disabled", shouldDisable);
      }
    });

    this.ensureVisibleSelection(thirdInputs);

    sizeInputs.forEach((input) => {
      if (input.hidden) return;

      const sizeVariants = selectedColorVariants.filter(
        (variant) => variant.option2 === input.value
      );
      const shouldDisable =
        sizeVariants.length > 0 &&
        sizeVariants.every((variant) => !variant.available);

      input.classList.toggle("disabled", shouldDisable);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;

    if (!this.isBundleBuilder) {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateFormID() {
    const formInput = this.form.querySelector('input[name="id"]');
    formInput.value = this.currentVariant.id;
  }

  updateSavingsLabel() {
    const savingsEls = document.querySelectorAll(".singles-and-packs__savings");
    if (!savingsEls.length || !this.currentVariant) return;
    const lastChanceColors = (this.form?.dataset?.lastChanceColors || "")
      .split(",").map((c) => c.trim().toLowerCase()).filter(Boolean);
    const selectedColor = (this.currentVariant.option1 || "").toLowerCase();
    const isLastChance = lastChanceColors.length > 0
      ? lastChanceColors.includes(selectedColor)
      : (this.currentVariant.compare_at_price || 0) > 0;
    savingsEls.forEach((el) => el.classList.toggle("hidden", isLastChance));
  }

  getSelectedColorValue() {
    const selectedColorInput =
      this.getOptionInputs(["Color", "Colour"]).find(
        (input) => input.checked && !input.hidden
      ) || this.getOptionInputs(["Color", "Colour"]).find((input) => !input.hidden);

    return selectedColorInput?.value || this.currentVariant?.option1 || "";
  }

  getColorAvailabilitySummary() {
    if (this._colorAvailabilitySummary) return this._colorAvailabilitySummary;

    const colorSummary = {};

    this.getVariantJSON().forEach((variant) => {
      if (!variant || !variant.option1 || !variant.option2) return;
      if ((variant.options || []).some((option) => String(option || "").startsWith("_"))) return;

      const colorKey = variant.option1;
      const sizeKey = variant.option2;

      colorSummary[colorKey] = colorSummary[colorKey] || {
        totalSizeCount: 0,
        oosSizeCount: 0,
        sizes: {},
      };

      const colorEntry = colorSummary[colorKey];
      colorEntry.sizes[sizeKey] = colorEntry.sizes[sizeKey] || {
        available: false,
      };

      if (variant.available) {
        colorEntry.sizes[sizeKey].available = true;
      }
    });

    Object.keys(colorSummary).forEach((colorKey) => {
      const sizeEntries = Object.values(colorSummary[colorKey].sizes || {});
      colorSummary[colorKey].totalSizeCount = sizeEntries.length;
      colorSummary[colorKey].oosSizeCount = sizeEntries.filter(
        (sizeEntry) => !sizeEntry.available
      ).length;
    });

    this._colorAvailabilitySummary = colorSummary;
    return colorSummary;
  }

  getSelectedColorOosSummary() {
    const selectedColor = this.getSelectedColorValue();
    const summary = this.getColorAvailabilitySummary()[selectedColor] || null;

    return {
      selectedColor,
      summary,
    };
  }

  buildOosShadeLinkUrl(color) {
    const baseUrl = this.form?.dataset?.oosShadeLinkBaseUrl;
    if (!baseUrl || !color) return "";

    const url = new URL(baseUrl, window.location.origin);
    const productHandle = this.form?.dataset?.handle;
    const productId = this.form?.dataset?.productId;

    url.searchParams.set("filter.v.option.color", color);
    if (productHandle) {
      url.searchParams.set("exclude-product-handle", productHandle);
    }
    if (productId) {
      url.searchParams.set("exclude-product-id", productId);
    }

    return url.toString();
  }

  async checkOosShadeDestinationAvailability(destination) {
    if (!destination) return false;

    if (!OOS_SHADE_DESTINATION_CACHE.has(destination)) {
      OOS_SHADE_DESTINATION_CACHE.set(
        destination,
        fetch(destination, {
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`OOS shade destination request failed: ${response.status}`);
            }
            return response.text();
          })
          .then((responseText) => {
            const parsed = new DOMParser().parseFromString(responseText, "text/html");
            const destinationUrl = new URL(destination, window.location.origin);
            const excludedHandle = destinationUrl.searchParams.get("exclude-product-handle") || "";
            const excludedProductId = destinationUrl.searchParams.get("exclude-product-id") || "";

            if (parsed.querySelector(".main-collection__no-products")) return false;

            const productCards = Array.from(
              parsed.querySelectorAll(
                "#product-grid .product-card, #ProductGridContainer .product-card, .collection-with-promo .product-card"
              )
            );

            if (!productCards.length) return false;

            return productCards.some((card) => {
              const cardHandle = card.dataset.productHandle || "";
              const cardProductId = card.dataset.productId || "";

              if (excludedHandle && cardHandle === excludedHandle) return false;
              if (excludedProductId && cardProductId === excludedProductId) return false;

              return true;
            });
          })
          .catch((error) => {
            console.error("Failed to verify OOS shade destination", error);
            OOS_SHADE_DESTINATION_CACHE.delete(destination);
            return false;
          })
      );
    }

    return OOS_SHADE_DESTINATION_CACHE.get(destination);
  }

  emitOosShadeLinkVisible(detail) {
    document.dispatchEvent(
      new CustomEvent("unbound:oos-shade-link:visible", {
        detail,
      })
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "unbound_oos_shade_link_visible",
      ...detail,
    });
  }

  bindOosShadeLinkTracking(link, detail) {
    if (!link) return;

    if (this._boundOosShadeLink && this._boundOosShadeLink !== link) {
      this._boundOosShadeLink.removeEventListener("click", this._boundOosShadeLinkHandler);
      this._boundOosShadeLink = null;
      this._boundOosShadeLinkHandler = null;
    }

    if (this._boundOosShadeLink === link) return;

    this._boundOosShadeLinkHandler = () => {
      const payload = {
        ...detail,
        destination: link.href,
      };

      document.dispatchEvent(
        new CustomEvent("unbound:oos-shade-link:click", {
          detail: payload,
        })
      );

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "unbound_oos_shade_link_click",
        ...payload,
      });
    };

    link.addEventListener("click", this._boundOosShadeLinkHandler);
    this._boundOosShadeLink = link;
  }

  async updateOosShadeLink() {
    const wrapper = this.form?.querySelector("[data-oos-shade-link-wrapper]");
    const link = this.form?.querySelector("[data-oos-shade-link]");
    if (!wrapper || !link) return;

    const threshold = Number(this.form?.dataset?.oosShadeLinkThreshold || 3);
    const { selectedColor, summary } = this.getSelectedColorOosSummary();
    const isVisible =
      !this.isBundleBuilder &&
      !this.multiAdd &&
      !!selectedColor &&
      !!summary &&
      summary.oosSizeCount >= threshold;

    if (!isVisible) {
      wrapper.classList.add("hidden");
      wrapper.setAttribute("aria-hidden", "true");
      this.form.dataset.oosShadeLinkVisible = "false";
      this.form.dataset.oosShadeLinkAvailable = "false";
      link.removeAttribute("href");
      link.dataset.selectedColor = "";
      link.dataset.oosSizeCount = "0";
      link.dataset.destinationAvailable = "false";
      this._lastOosShadeLinkVisibleKey = "";
      return;
    }

    const destination = this.buildOosShadeLinkUrl(selectedColor);
    if (!destination) {
      wrapper.classList.add("hidden");
      wrapper.setAttribute("aria-hidden", "true");
      this.form.dataset.oosShadeLinkVisible = "false";
      this.form.dataset.oosShadeLinkAvailable = "false";
      link.dataset.destinationAvailable = "false";
      return;
    }

    const requestKey = `${selectedColor}:${summary.oosSizeCount}:${destination}`;
    this._oosShadeLinkRequestKey = requestKey;

    wrapper.classList.add("hidden");
    wrapper.setAttribute("aria-hidden", "true");
    this.form.dataset.oosShadeLinkVisible = "false";
    this.form.dataset.oosShadeLinkAvailable = "pending";

    const destinationAvailable = await this.checkOosShadeDestinationAvailability(destination);
    if (this._oosShadeLinkRequestKey !== requestKey) return;

    if (!destinationAvailable) {
      this.form.dataset.oosShadeLinkAvailable = "false";
      link.removeAttribute("href");
      link.dataset.destinationAvailable = "false";
      this._lastOosShadeLinkVisibleKey = "";
      return;
    }

    const detail = {
      productHandle: this.form?.dataset?.handle || "",
      variantId: this.currentVariant?.id || null,
      selectedColor,
      oosSizeCount: summary.oosSizeCount,
      totalSizeCount: summary.totalSizeCount,
      threshold,
      destination,
      destinationAvailable,
    };

    wrapper.classList.remove("hidden");
    wrapper.setAttribute("aria-hidden", "false");
    this.form.dataset.oosShadeLinkVisible = "true";
    this.form.dataset.oosShadeLinkAvailable = "true";
    link.href = destination;
    link.dataset.selectedColor = selectedColor;
    link.dataset.oosSizeCount = String(summary.oosSizeCount);
    link.dataset.destinationAvailable = "true";
    this.bindOosShadeLinkTracking(link, detail);

    const visibleKey = `${selectedColor}:${summary.oosSizeCount}:${destination}:true`;
    if (this._lastOosShadeLinkVisibleKey !== visibleKey) {
      this.emitOosShadeLinkVisible(detail);
      this._lastOosShadeLinkVisibleKey = visibleKey;
    }
  }

  updateProductInfo(e) {
    // Debounce — cancel pending timer
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => this._doUpdateProductInfo(e), 80);
  }

  _doUpdateProductInfo(e) {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

    // Cancel any in-flight fetch
    if (this._fetchController) this._fetchController.abort();
    this._fetchController = new AbortController();
    const signal = this._fetchController.signal;

    const applyInfo = (responseText) => {
      const idPrice = `price-${this.dataset.section}`;
      const idMedia = `media-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, "text/html");

      const oldPriceDesktop = document.querySelector(".product-info-above-description-desktop")?.querySelector(`#${idPrice}`);
      const newPriceDesktop = html.querySelector(".product-info-above-description-desktop")?.querySelector(`#${idPrice}`);
      const oldPriceMobile = document.querySelector(".product-info-above-description-mobile")?.querySelector(`#${idPrice}`);
      const newPriceMobile = html.querySelector(".product-info-above-description-mobile")?.querySelector(`#${idPrice}`);
      const oldAfterpay = document.querySelector(".product__afterpay");
      const newAfterpay = html.querySelector(".product__afterpay");
      const oldProductMedia = document.getElementById(idMedia);
      const newProductMedia = html.getElementById(idMedia);
      const currentVariantColor = this.form.querySelector(".option-heading__current-color");
      const oldCTA = this.form.querySelector(".product-form__cta");
      const newCTA = html.querySelector(".product-form__cta");
      const hadBisProxy = !!oldCTA?.querySelector(".js-klaviyo-bis-proxy");
      const oldPreorderModal = document.querySelector(".preorder-confirmation-modal");
      const newPreorderModal = html.querySelector(".preorder-confirmation-modal");
      const oldDetailsTab = document.querySelector(".product-tab.tab-the-details .product-tab__content");
      const newDetailsTab = html.querySelector(".product-tab.tab-the-details .product-tab__content");
      const oldProductFabric = document.querySelector(".product-fabric");
      const newProductFabric = html.querySelector(".product-fabric");
      const oldModelInfoDesktop = document.querySelector(".model-info--desktop");
      const newModelInfoDesktop = html.querySelector(".model-info--desktop");
      const oldModelInfofit = document.querySelector(".fit-review__title--fit");
      const newModelInfofit = html.querySelector(".fit-review__title--fit");
      const oldFeaturedImage = document.querySelector(".product-media__gallery--slider .keen-slider__slide:first-child img");
      const newFeaturedImage = html.querySelector(".product-media__gallery--slider .keen-slider__slide:first-child img");
      const oldOptionHeadingColor = this.form.querySelector(".option-heading--color");
      const newOptionHeadingColor = html.querySelector(".option-heading--color");
      const oldDescription = document.querySelector(".product-description");
      const newDescription = html.querySelector(".product-description");
      const oldDescriptionAll = document.querySelectorAll(".js-product-description");
      const bundleSavingMessage = document.querySelector(".bundle-builder__savings-message");

      if (!this.isBundleBuilder) {
        if (oldPriceDesktop && newPriceDesktop) oldPriceDesktop.innerHTML = newPriceDesktop.innerHTML;
        if (oldPriceMobile && newPriceMobile) oldPriceMobile.innerHTML = newPriceMobile.innerHTML;
        if (oldAfterpay && newAfterpay) oldAfterpay.innerHTML = newAfterpay.innerHTML;

        // Update save badge for regular products with compare_at_price
        const cv = this.currentVariant;
        if (cv && cv.compare_at_price > cv.price) {
          const saveAmount = cv.compare_at_price - cv.price;
          showPdpSaveBadge(saveAmount);
        } else if (!showPackPillBadgeIfAvailable()) {
          hidePdpSaveBadge();
        }

        this.updateSavingsLabel();
      } else {
        const bundleType = document.querySelector(".bundle-builder");
        const skipLastChancePricingLogic = bundleType?.dataset?.skipLastChancePricingLogic;
        if (skipLastChancePricingLogic == "true") return;
        const isMixedBundle = bundleType.classList.contains(
          "bundle-builder--mixed_bundle"
        );

        let formattedBasePrice = "";
        let formatedSavings = "";
        let priceHolderDesktop = "";
        let priceHolderMobile = "";

        if (isMixedBundle) {
          bundleType.updateMixedBundlePrice?.();
        } else if (bundleType.classList.contains("bundle-builder--pack")) {
          formattedBasePrice = bundleSavingMessage.dataset.basePrice;
          formatedSavings = bundleSavingMessage.dataset.bundleBaseSaveAmount;
          priceHolderDesktop = oldPriceDesktop.parentElement.querySelector(".pack-price");
          priceHolderMobile = oldPriceMobile.parentElement.querySelector(".pack-price");
        } else {
          formattedBasePrice = oldPriceDesktop.querySelector(".price").dataset.basePrice;
          formatedSavings = oldPriceDesktop.querySelector(".price").dataset.bundleBaseSaveAmount;
          priceHolderDesktop = oldPriceDesktop.querySelector(".price-item--regular");
          priceHolderMobile = oldPriceMobile.querySelector(".price-item--regular");
        }
        if (!isMixedBundle) {
          const normalizePrice = (str) => parseFloat(str.replace(/[^0-9,\.]/g, "").replace(/\.(?=\d{3})/g, "").replace(",", "."));
          let baseBundlePrice = normalizePrice(formattedBasePrice);
          let currency = getActiveMoneyPrefix(formattedBasePrice);
          let lastChanceSavings = 0;
          let renderedSavings = normalizePrice(formatedSavings);

          document.querySelectorAll("bundle-builder-row").forEach((row) => {
            if (row.dataset.lastChanceSavings && row.dataset.lastChanceSavings != "0") {
              lastChanceSavings += parseFloat(row.dataset.lastChanceSavings);
            }
          });

          if (lastChanceSavings != 0) {
            let discountedBundlePrice = baseBundlePrice - lastChanceSavings;
            let formattedDisctountedPrice = currency + discountedBundlePrice;
            renderedSavings += lastChanceSavings;

            priceHolderDesktop.innerHTML = formattedDisctountedPrice;

            const priceWrapDesktop = oldPriceDesktop?.closest(".product-info-above-description-desktop");
            const savingLabelDesktop = priceWrapDesktop?.querySelector(".product-price__saving-label");
            if (savingLabelDesktop) savingLabelDesktop.innerText = "Save " + stripSavingsLabelDecimals(currency + renderedSavings);

            priceHolderMobile.innerHTML = formattedDisctountedPrice;

            const priceWrapMobile = oldPriceMobile?.closest(".product-info-above-description-mobile");
            const savingLabelMobile = priceWrapMobile?.querySelector(".product-price__saving-label");
            if (savingLabelMobile) savingLabelMobile.innerText = "Save " + stripSavingsLabelDecimals(currency + renderedSavings);
            
            if (bundleSavingMessage) {
              const totalEl = bundleSavingMessage.querySelector(".total");
              const savingsEl = bundleSavingMessage.querySelector(".savings");
              if (totalEl) totalEl.innerText = formattedDisctountedPrice;
              if (savingsEl) savingsEl.innerText = stripSavingsLabelDecimals(currency + renderedSavings);
            }
            
            const afterpayPrice = document.querySelector(".afterpay-price");
            if (afterpayPrice) afterpayPrice.innerHTML = currency + formatInstalment(discountedBundlePrice / 4);
          } else {
            priceHolderDesktop.innerHTML = formattedBasePrice;
            priceHolderMobile.innerHTML = formattedBasePrice;

            const priceWrapDesk = oldPriceDesktop?.closest(".product-info-above-description-desktop");
            const savingLabelDesk = priceWrapDesk?.querySelector(".product-price__saving-label");
            if (savingLabelDesk) savingLabelDesk.innerText = "Save " + stripSavingsLabelDecimals(currency + renderedSavings);

            const priceWrapMob = oldPriceMobile?.closest(".product-info-above-description-mobile");
            const savingLabelMob = priceWrapMob?.querySelector(".product-price__saving-label");
            if (savingLabelMob) savingLabelMob.innerText = "Save " + stripSavingsLabelDecimals(currency + renderedSavings);

            const bundleTotal = bundleSavingMessage?.querySelector(".total");
            if (bundleTotal) bundleTotal.innerText = formattedBasePrice;

            const bundleSavings = bundleSavingMessage?.querySelector(".savings");
            if (bundleSavings) bundleSavings.innerText = stripSavingsLabelDecimals(formatedSavings);

            const afterpayPrice = document.querySelector(".afterpay-price");
            if (afterpayPrice) afterpayPrice.innerHTML = currency + formatInstalment(baseBundlePrice / 4);
          }
        }
      }

      if (oldCTA && newCTA) {
        oldCTA.innerHTML = newCTA.innerHTML;
        const nextBisProxy = oldCTA.querySelector(".js-klaviyo-bis-proxy");

        if ((hadBisProxy || nextBisProxy) && typeof window.queueKlaviyoBackInStockInit === "function") {
          requestAnimationFrame(() => {
            window.queueKlaviyoBackInStockInit(0);
            bindKlaviyoBisProxyButtons();
            applyRestockDateBisFilter(this.currentVariant?.id);
          });
        } else if (hadBisProxy || nextBisProxy) {
          requestAnimationFrame(() => {
            bindKlaviyoBisProxyButtons();
            applyRestockDateBisFilter(this.currentVariant?.id);
          });
        } else {
          requestAnimationFrame(() => {
            applyRestockDateBisFilter(this.currentVariant?.id);
          });
        }
      }
      addToCartBtnFunction();

      if (!this.isBundleBuilder) {
        if (oldPreorderModal && newPreorderModal) oldPreorderModal.innerHTML = newPreorderModal.innerHTML;
        preorderFunction();
      }

      if (!this.isBundleBuilder) {
        if (oldDescription && newDescription) {
          oldDescriptionAll.forEach((el) => (el.innerHTML = newDescription.innerHTML));
        }

        if (oldDetailsTab && newDetailsTab) oldDetailsTab.innerHTML = newDetailsTab.innerHTML;
        if (oldProductFabric && newProductFabric) oldProductFabric.innerHTML = newProductFabric.innerHTML;
        productDimensions();
        learnMoreFunction();
        micronChart();
        micronModalFunction();
      }

      if (oldFeaturedImage?.dataset?.id !== newFeaturedImage?.dataset?.id) {
        const productTags = window?.productData?.tags || [];
        const skipGalleryUpdate = productTags.some((tag) =>
          ["black-friday-giftset", "black-friday-variety", "black-friday-ownbox"].includes(tag)
        );

        if (!skipGalleryUpdate) {
          if (oldProductMedia && newProductMedia) {
            const oldGalleryEl = document.querySelector(".product-media__gallery--slider");
            const oldGalleryBottom = oldGalleryEl ? oldGalleryEl.getBoundingClientRect().bottom + window.scrollY : window.scrollY;
            oldProductMedia.innerHTML = newProductMedia.innerHTML;
            this.recreateSlider(oldGalleryBottom);
          }
        }

        featuredImagesZoom();

        if (oldModelInfoDesktop && newModelInfoDesktop) {
          oldModelInfoDesktop.innerHTML = newModelInfoDesktop.innerHTML;
        } else if (oldModelInfoDesktop) {
          oldModelInfoDesktop.innerHTML = "";
        }

        if (oldModelInfofit && newModelInfofit) {
          oldModelInfofit.innerHTML = newModelInfofit.innerHTML;
        } else if (oldModelInfofit) {
          oldModelInfofit.innerHTML = "";
        }

        if (currentVariantColor) currentVariantColor.innerHTML = this.currentVariant.option1;

        modelInfoMobile();
      }

      this.checkAvailableOptions(e, html);
      hideBIShiddenOptions();
      selectASizeBtnClick();

      if (!this.isBundleBuilder) {
        if (this.form.classList.contains("product-form--size-selected")) {
          this.form.classList.add("product-info-updated");
        }
      }

      checkTheFitContent();
      adjustActiveProductTabHeight();
      window.unboundSyncWoolmarkTest?.();

      if (!this.isBundleBuilder) {
        const notifyMeLink = document.querySelector(".info__notify-me");
        let hideNotifyMe = false;

        if (notifyMeLink) {
          const currentColor = currentVariantColor?.innerText?.trim()?.toLowerCase() || "";
          if (isBisDisabledColor(currentColor, this.form)) hideNotifyMe = true;
        }

        if (notifyMeLink && hideNotifyMe) notifyMeLink.classList.remove("active");
      }

      if (oldOptionHeadingColor && newOptionHeadingColor) oldOptionHeadingColor.innerHTML = newOptionHeadingColor.innerHTML;

      toggleBlendWrapsGlobal(
        getVariantOptionValue(this.currentVariant, "color") || this.currentVariant?.option1 || "",
        getVariantOptionValue(this.currentVariant, "size")
      );

      this.updateOosShadeLink();
    }; // end applyInfo

    // Return cached result immediately if available
    if (this._fetchCache[url]) {
      applyInfo(this._fetchCache[url]);
      return;
    }

    fetch(url, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        if (!signal.aborted) {
          this._fetchCache[url] = responseText;
          applyInfo(responseText);
        }
      })
      .catch((err) => { if (err.name !== 'AbortError') console.error(err); });
  }



  recreateSlider(oldGalleryBottom) {
    createProductSlider();
    // Query the newly created gallery element
    const gallery = document.querySelector('.product-media__gallery--slider');

    // Wait for new gallery height to stabilize before adjusting scroll
    requestAnimationFrame(() => {
      if (typeof ResizeObserver === 'function') {
        const observer = new ResizeObserver(() => {
          const newGalleryBottom = gallery.getBoundingClientRect().bottom + window.scrollY;
          const heightDiff = newGalleryBottom - oldGalleryBottom;

          if (heightDiff >= 0) {
            observer.disconnect();
            return;
          }

          // Keep scroll position aligned with the gallery change
          window.scrollBy({
            top: heightDiff,
            behavior: 'smooth',
          });

          observer.disconnect();
        });

        observer.observe(gallery);
      } else {
        // Fallback for environments without ResizeObserver
        setTimeout(() => {
          const newGalleryBottom = gallery.getBoundingClientRect().bottom + window.scrollY;
          const heightDiff = newGalleryBottom - oldGalleryBottom;

          if (heightDiff >= 0) {
            return;
          }

          window.scrollBy({ top: heightDiff, behavior: 'smooth' });
        }, 0);
      }
    });
  }

checkAvailableOptions(e, html) {
  if (!e) return;
  if (
    e.target.attributes.option?.nodeValue === "Color" ||
    e.target.attributes.option?.nodeValue === "Size"
  ) {
    const form = e.target.closest(".product-form");
    const allInputs = form.querySelectorAll("input");

    const selectedColorEl = html.querySelector(
      '.product-form input[option="Color"][checked]'
    );

    if (!selectedColorEl) return;

    const selectedColorVariants = this.getVariantJSON().filter((variant) => {
      return variant.option1 === selectedColorEl.value;
    });

    let thirdInputs = form.querySelectorAll('input[option="Inseam"]');
    if (thirdInputs.length === 0) {
      thirdInputs = form.querySelectorAll('input[option="Length"]');
    }
    const sizeInputs = form.querySelectorAll('input[option="Size"]');
    const notifyMeLink = document.querySelector(".info__notify-me");

    allInputs.forEach((input) => {
      input.classList.remove("disabled");
      input.setAttribute("data-counter", 0);
    });
    if (notifyMeLink) notifyMeLink.classList.remove("active");

    selectedColorVariants.forEach((variant) => {
      if (!variant.available) {
        if (variant.option2 && !variant.option3)
          this.checkSizesOnly(sizeInputs, variant);
        if (variant.option2 && variant.option3)
          this.checkSizesAndThird(sizeInputs, thirdInputs, variant, selectedColorVariants, html);
      }
    });

    if (selectedColorVariants.some((variant) => !variant.available)) {
      if (notifyMeLink) notifyMeLink.classList.add("active");
    }
  }
}

  checkSizesOnly(sizeInputs, variant) {
    sizeInputs.forEach((input) => {
      if (variant.option2 === input.value) input.classList.add("disabled");
    });
  }

  checkSizesAndThird(
    sizeInputs,
    thirdInputs,
    variant,
    selectedColorVariants,
    html
  ) {
    // ===== First ===== Disable Size Option if all Thirds are not available
    sizeInputs.forEach((inputSize) => {
      if (variant.option2 === inputSize.value)
        inputSize.setAttribute(
          "data-counter",
          `${Number(inputSize.getAttribute("data-counter")) + 1}`
        );

      // If the 'data-counter' value = the number of Third Inputs, means all thirds are not available for this size
      // We can now disable this size
      if (
        Number(inputSize.getAttribute("data-counter")) === thirdInputs.length
      )
        inputSize.classList.add("disabled");
    });

    // ===== Second ===== Disable OOS Third Options
    // 1- Get Current Checked Size
    const currentSize = html.querySelector(
      '.product-form input[option="Size"][checked]'
    );

    // 2- Get all variants with the same checked size
    // 3- If variant is not available, disable the third option
    selectedColorVariants.forEach((el) => {
      if (el.option2 === currentSize.value && !el.available) {
        thirdInputs.forEach((inputThird) => {
          if (el.option3 === inputThird.value)
            inputThird.classList.add("disabled");
        });
      }
    });
  }

  updateBundleBuilder() {
    // 1. Check if current variant is available
    const confirmBtn = this.form.querySelector(".bundle-builder__confirm");
    const bundleBuilderATC = this.bundleBuilderEl.querySelector(
      ".bundle-builder-add-to-cart"
    );
    const soldOutEl = this.form.querySelector(".bundle-builder__sold-out");
    const bundleBuilderRowHeaders = this.bundleBuilderEl.querySelectorAll(
      ".bundle-builder-row__header"
    );
    const thisRow = this.form.closest(".bundle-builder-row");
    const bundleBuilderStepHeaders = document.querySelectorAll(
      ".bundle-builder-step__header"
    );

    if (!this.currentVariant.available) {
      // 1. Restrict this row
      thisRow.classList.add("restricted");

      // 2. Restrict all headers
      bundleBuilderRowHeaders.forEach((el) => el.classList.add("restricted"));

      // 3. Restrict confirm button
      confirmBtn.classList.add("restricted");

      // 4. Restrict ATC button
      bundleBuilderATC.classList.add("restricted");

      // 5. Show sold out
      soldOutEl.classList.remove("hidden");

      // 6. Adjust row height
      thisRow.heightAnimation();

      // 7. Disable Step heading
      if (bundleBuilderStepHeaders.length > 0) {
        bundleBuilderStepHeaders.forEach((el) =>
          el.classList.add("restricted")
        );
      }
    } else {
      thisRow.classList.remove("restricted");
      bundleBuilderRowHeaders.forEach((el) =>
        el.classList.remove("restricted")
      );
      confirmBtn.classList.remove("restricted");
      bundleBuilderATC.classList.remove("restricted");
      soldOutEl.classList.add("hidden");
      thisRow.heightAnimation();
      if (bundleBuilderStepHeaders.length > 0) {
        bundleBuilderStepHeaders.forEach((el) =>
          el.classList.remove("restricted")
        );
      }
    }

    // 2. Show selected variant title
    const selectedVariantEl = this.form
      .closest(".bundle-builder-row")
      .querySelector(".bundle-builder-row__selected-variant");
    let selectedVariantTitle;

    setTimeout(() => {
      const selectedStyle = this.form
        .closest(".bundle-builder-row")
        .querySelector('.style-icon input[type="radio"]:checked');

      if (selectedStyle) {
        const styleTitle = selectedStyle
          .closest(".style-icon")
          .querySelector(".style-icon__title").textContent;
        selectedVariantTitle = `${styleTitle} / ${this.currentVariant.title}`;
      } else {
        selectedVariantTitle = this.currentVariant.title;
      }

      selectedVariantEl.textContent = selectedVariantTitle;

      // 3. check if the selected variant is a last chance or not
      const lastChanceColors = this.closest(".product-form").dataset.lastChanceColors.split(",").map(c => c.trim().toLowerCase());
      const lastChanceSavings = this.closest(".product-form").dataset.savings;
      if (lastChanceColors.length > 0 && parseFloat(lastChanceSavings) != 0) {
        const match = lastChanceColors.find(color =>  selectedVariantTitle.toLowerCase().includes(color) );
        this.closest(".bundle-builder-row").dataset.lastChanceSavings = match ? lastChanceSavings : '0';        
      }else{
        this.closest(".bundle-builder-row").dataset.lastChanceSavings = '0';         
      }

      const bundleBuilderEl = this.closest("bundle-builder");
      if (bundleBuilderEl) {
        bundleBuilderEl.calcSavings();
        bundleBuilderEl.updateMultiTiresBtns();
        bundleBuilderEl.updatePackPrice();
        bundleBuilderEl.updateMixedBundlePrice?.();
      }


    }, 300);

  }

  updateMultiAdd() {
    this.getAvailableOptions();
    this.getAvailableVariants();
    this.addVariantsInfo();
    this.resetQuantity();
  }

  getAvailableOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".js-product-form-option")
    );
    let currentSize;
    let allColors = [];
    let availableOptions = [];
    let availableOptionsArray = [];
    let arraySize = 2;

    fieldsets.forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach((input) => {
        if (
          input.getAttribute("option") === "Size" ||
          input.getAttribute("option") === "size"
        ) {
          if (input.checked) currentSize = input.value;
        } else if (
          input.getAttribute("option") === "Color" ||
          input.getAttribute("option") === "color"
        ) {
          allColors.push(input.value);
        }
      });
    });

    allColors.forEach((color) => {
      availableOptions.push(color, currentSize);
    });

    for (let i = 0; i < availableOptions.length; i += arraySize) {
      availableOptionsArray.push(availableOptions.slice(i, i + arraySize));
    }

    return availableOptionsArray;
  }

  getAvailableVariants() {
    const availableOptionsArray = this.getAvailableOptions();
    let availableVariantsArray = [];

    availableOptionsArray.forEach((el) => {
      let availableVariant = this.getVariantJSON().find((variant) => {
        const findings = !variant.options
          .map((option, index) => {
            return option === el[index];
          })
          .includes(false);

        if (findings) return variant;
      });

      availableVariantsArray.push(availableVariant);
    });

    return availableVariantsArray;
  }

  addVariantsInfo() {
    const availableVariantsArray = this.getAvailableVariants();
    const multiAddColorContainers = document.querySelectorAll(
      ".multi-add__color-container"
    );

    multiAddColorContainers.forEach((container) => {
      const containerColor = container.dataset.color;
      const OOSLabel = container.querySelector(".color-swatch__OOS");
      const quantityBtns = container.querySelectorAll(".quantity__button");
      const preorderLabel = container.querySelector(".color-swatch__preorder");

      container.removeAttribute("data-preorder");
      preorderLabel.classList.add("hidden");

      availableVariantsArray.forEach((variant) => {
        if (variant.option1 === containerColor) {
          const preorderLookup = this.form?.querySelector(
            `.preorder__line-item-property input[data-property-key="_Pre-order"][data-variant-id="${variant.id}"]`
          );
          const preorderValue = preorderLookup?.value?.trim() || "";

          container.setAttribute("variant-id", variant.id);
          container.setAttribute(
            "available-quantity",
            variant.inventory_quantity
          );

          if (variant.inventory_quantity < 1) {
            OOSLabel.classList.remove("hidden");
            quantityBtns.forEach((btn) => btn.classList.add("disabled"));
            preorderLabel.classList.add("hidden");
          } else {
            OOSLabel.classList.add("hidden");
            quantityBtns.forEach((btn) => btn.classList.remove("disabled"));
            if (preorderValue) {
              container.setAttribute("data-preorder", preorderValue);
              preorderLabel.classList.remove("hidden");
            }
          }
        }
      });
    });
  }

  resetQuantity() {
    const allQuantityInputs = document.querySelectorAll(
      ".multi-add__quantity-input"
    );
    const counter = document.querySelector(
      ".multi-add__counter .selected-counter"
    );
    const multiAddAddToCartBtn = document.querySelector(
      ".multi-add-add-to-cart"
    );
    allQuantityInputs.forEach((input) => (input.value = 0));
    counter.textContent = 0;
    multiAddAddToCartBtn.innerHTML = "Select Colors";
    multiAddAddToCartBtn.classList.add("disabled");
  }
}

customElements.define("variant-radios", VariantRadios);
// ==================== End VariantRadios Class ====================

// ==================== Start Upsell Popup ====================
function getPackOfferBadgeText() {
  return stripSavingsLabelDecimals(
    applyActiveCurrencyPrefixToText(
      document
      .querySelector(
        ".singles-and-packs__bundle-builder .bundle-builder__savings-message, .bundle-builder__savings-message"
      )
      ?.dataset?.singlesAndPacksSavings?.trim()
    )
  );
}

function applyPackOfferBadge() {
  const badges = document.querySelectorAll(".singles-and-packs__savings");
  const badgeText = getPackOfferBadgeText();

  if (!badgeText || !badges.length) return false;

  badges.forEach((badge) => {
    badge.textContent = badgeText;
    badge.style.display = "";
    badge.classList.remove("hidden");
  });

  syncProductLabelSavingsVisibility();
  return true;
}

function syncPackSavingsBadge() {
  const bundleBuilder = document.querySelector(
    ".singles-and-packs__bundle-builder .bundle-builder, .bundle-builder"
  );

  bundleBuilder?.updatePackPrice?.();

  const bundleSavingsMessage = bundleBuilder?.querySelector(
    ".bundle-builder__savings-message"
  );
  const savingsEl = bundleSavingsMessage?.querySelector(".savings");
  const singlesAndPacksSavings = applyActiveCurrencyPrefixToText(
    bundleSavingsMessage?.dataset?.singlesAndPacksSavings?.trim()
  );
  const rawSavings = applyActiveCurrencyPrefixToText(
    savingsEl?.textContent?.trim() ||
    bundleSavingsMessage?.dataset?.bundleBaseSaveAmount?.trim()
  );
  const rawPackThreshold = bundleSavingsMessage?.dataset?.packThreshold?.trim();
  const packThreshold = Number.parseInt(rawPackThreshold, 10);

  const badges = document.querySelectorAll(".singles-and-packs__savings");

  if ((!singlesAndPacksSavings && !rawSavings) || !badges.length) return;

  const formattedSavings = rawSavings
    ? stripSavingsLabelDecimals(rawSavings)
    : "";
  const packCopy = Number.isFinite(packThreshold) && packThreshold > 0
    ? ` on ${packThreshold} ${packThreshold === 1 ? "pack" : "packs"}`
    : "";

  badges.forEach((badge) => {
    badge.textContent = stripSavingsLabelDecimals(singlesAndPacksSavings || `Save ${formattedSavings}${packCopy}`);
    badge.style.display = "";
    badge.classList.remove("hidden");
  });

  syncProductLabelSavingsVisibility();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    syncPackSavingsBadge();
    // Show pack pill on page load only if no sale badge already rendered by Liquid
    if (!document.querySelector("#pdp-save-badge")) {
      showPackPillBadgeIfAvailable();
    }
  });
} else {
  syncPackSavingsBadge();
  if (!document.querySelector("#pdp-save-badge")) {
    showPackPillBadgeIfAvailable();
  }
}

class UpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.addToCartBtns = this.querySelectorAll('.upsell-popup__add-to-cart');
    this.headers = this.querySelectorAll('.upsell-popup__header');
    this.price = this.querySelector('.upsell-popup__price');
    this.shopNowBtn = this.querySelector('.upsell-popup__shop');

    document.addEventListener('DOMContentLoaded', this.updateUpsellInfo.bind(this));
    this.addEventListener('click', this.onUpsellPopupClick.bind(this));
    window.addEventListener('keydown', this.onKeydownClick.bind(this));
    this.addToCartBtns.forEach(btn => {
      btn.addEventListener('click', this.onAddToCartBtnClick.bind(this));
    })
    this.shopNowBtn.addEventListener('click', this.onShopNowBtnClick.bind(this));

  }


  updateUpsellInfo() {
    const bundleBuilderSavings = document.querySelector('.bundle-builder__savings-message');
    const priceBadge = this.querySelector('.upsell-popup__save-text'); // Badge for displaying savings

    // Get the savings text and add "SAVE" in front of the amount
    const savingsText = `SAVE ${bundleBuilderSavings?.dataset.bundleBaseSaveAmount}`; // Add "SAVE" in front of the savings

    if (priceBadge) {
      priceBadge.textContent = savingsText; // Set the savings amount in the badge
    }

    this.headers.forEach(header => header.textContent = bundleBuilderSavings?.dataset.upsellHeader);
    this.price.textContent = bundleBuilderSavings?.dataset.upsellPrice;
  }

  openUpsellPopup() {
    this.classList.remove("hidden");
    document.body.classList.add("upsell-popup-open", "overflow-hidden");
  }

  closeUpsellPopup() {
    this.classList.add("hidden");
    document.body.classList.remove("upsell-popup-open", "overflow-hidden");
  }

  onUpsellPopupClick(e) {
    if (e.target === this) {
      this.closeUpsellPopup();
      updateCart();
    }
  }

  onKeydownClick(e) {
    if (e.key === "Escape") {
      if (!this.classList.contains("hidden")) updateCart();
      this.closeUpsellPopup();
    }
  }

  onAddToCartBtnClick() {
    this.closeUpsellPopup();
    updateCart();
  }

onShopNowBtnClick() {
  const packSelector = document.querySelector('.singles-and-packs__btn[data-type="packs"]');
  const productInfoInner = document.querySelector('.product-info__inner');

  // Close the popup first
  this.closeUpsellPopup();

  // Switch to "packs" view if available
  packSelector?.click();
  productInfoInner?.classList.add('pack');
  requestAnimationFrame(() => syncPackSavingsBadge());

  // Utility: wait until an element exists in DOM (used for dynamic rendering)
  const waitForEl = (selector, timeout = 5000) => {
    return new Promise((resolve) => {
      const start = performance.now();

      const tick = () => {
        const el = document.querySelector(selector);
        if (el) return resolve(el);
        if (performance.now() - start > timeout) return resolve(null);
        requestAnimationFrame(tick);
      };

      tick();
    });
  };

  // Open row only if it is not already active
  const openRowIfClosed = (row) => {
    if (!row) return null;

    const header = row.querySelector('.bundle-builder-row__header');
    if (!header) return null;

    // If row is already open, do nothing
    if (!row.classList.contains('active')) {
      header.click();
    }

    return header;
  };

  (async () => {
    // Wait until bundle rows container is rendered
    const rowsWrap = await waitForEl('.bundle-builder__rows', 4000);
    if (!rowsWrap) return;

    syncPackSavingsBadge();

    // Get first row (prefer explicit data-index if exists)
    const firstRow =
      document.querySelector('.bundle-builder-row[data-index="1"]') ||
      document.querySelector('.bundle-builder-row');

    if (!firstRow) return;

    // Open the row safely (no double toggle)
    const firstRowHeader = openRowIfClosed(firstRow);

    // Add temporary highlight animation to header
    if (firstRowHeader) {
      firstRowHeader.classList.add('pulse-highlight');
      setTimeout(() => {
        firstRowHeader.classList.remove('pulse-highlight');
      }, 2000);
    }
  })();
}



}

customElements.define("upsell-popup", UpsellPopup);
// ==================== End Upsell Popup ====================

// ==================== Start Form Add to Cart Button ====================
// ===== Start Helper Functions =====
const updateCart = function () {
  const cart = document.querySelector("cart-drawer");
  const form = document.querySelector(".product-form #product-form");
  const btn = document.querySelector(".product-form__cta .add-to-cart-button");
  const productForm = form?.closest(".product-form");
  const activeSelection = productForm ? getActiveVariantSelection(productForm) : null;

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData(form);
  const variantId = form?.querySelector('input[name="id"]')?.value?.trim();
  const preorderInput =
    variantId && productForm
      ? productForm.querySelector(
          `.preorder__line-item-property input[data-property-key="_Pre-order"][data-variant-id="${variantId}"]`
        )
      : null;

  if (preorderInput?.value?.trim()) {
    if (!formData.has("properties[_Pre-order]")) {
      formData.append("properties[_Pre-order]", preorderInput.value.trim());
    }
  } else {
    formData.delete("properties[_Pre-order]");
  }

  if (cart) {
    formData.append(
      "sections",
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  if (btn) btn.classList.add("loading");

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (activeSelection?.size) {
        persistLastCartSizeSelection(activeSelection.size, "add-to-cart");
      }

      window.UnboundSearchTracking?.trackAttributedAddToCart?.(
        {
          productId: window.productData?.id || response?.product_id || "",
        },
        { transport: "fetch" },
      );
      cart.renderContents(response);
      cart.openCloseCart();
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (btn) btn.classList.remove("loading");
      if (cart && cart.classList.contains("is-empty"))
        cart.classList.remove("is-empty");
    });
};
// ===== End Helper Functions =====

const addToCartBtnFunction = function () {
  const addToCartBtn = document.querySelector(
    ".product-form__cta .add-to-cart-button"
  );
  const upsellPopup = document.querySelector(".upsell-popup");

  if (!addToCartBtn) return;

  addToCartBtn.addEventListener("click", function (e) {
    e.preventDefault();

    if (addToCartBtn.classList.contains("loading")) return;

    if (upsellPopup) {
      // Check Cookie
      const cookieName = `upsellPopup-${
        document.querySelector(".main-product").dataset.handle
      }`;
      const upsellPopupCookie = getCookie(cookieName);

      if (upsellPopupCookie) {
        // upsellPopupCookie = True, means the user already saw it
        // Then add to cart
        updateCart();
      } else {
        // 1- Open upsell popup
        upsellPopup.openUpsellPopup();
        // 2- Update Cookies
        setCookie(cookieName, true, 1);
      }
    } else {
      updateCart();
    }
  });
};

document.addEventListener("DOMContentLoaded", addToCartBtnFunction);
// ==================== End Form Add to Cart Button ====================

// ==================== Start Check Unavailable options on load ====================
// Helper Function
const checkSizesAndThirdOnLoad = function (
  sizeInputs,
  thirdInputs,
  variant,
  selectedColorVariants
) {
  // ===== First ===== Disable Size Option if all Thirds are not available
  sizeInputs.forEach((inputSize) => {
    if (variant.option2 === inputSize.value)
      inputSize.setAttribute(
        "data-counter",
        `${Number(inputSize.getAttribute("data-counter")) + 1}`
      );

    // If the 'data-counter' value = the number of Third Inputs, means all thirds are not available for this size
    // We can now disable this size
    if (Number(inputSize.getAttribute("data-counter")) === thirdInputs.length)
      inputSize.classList.add("disabled");
  });

  // ===== Second ===== Disable OOS Third Options
  // 1- Get Current Checked Size
  const currentSize = document.querySelector(
    '.product-form input[option="Size"][checked]'
  );

  // 2- Get all variants with the same checked size
  // 3- If variant is not available, disable the third option
  selectedColorVariants.forEach((el) => {
    if (el.option2 === currentSize.value && !el.available) {
      thirdInputs.forEach((inputThird) => {
        if (el.option3 === inputThird.value)
          inputThird.classList.add("disabled");
      });
    }
  });
};

const getProductVariants = () =>
  window?.productData?.variants ||
  window?.productData?.product?.variants ||
  window?.__product?.variants ||
  [];

const getProductOptionNames = () => {
  const optionNames =
    window?.productData?.options ||
    window?.productData?.product?.options ||
    window?.__product?.options ||
    [];

  return Array.isArray(optionNames) ? optionNames : [];
};

const getVariantOptionValue = (variant, optionName) => {
  const normalizedOptionName = String(optionName || "").trim().toLowerCase();
  if (!variant || !normalizedOptionName) return "";

  const optionNames = getProductOptionNames();
  const optionIndex = optionNames.findIndex(
    (name) => String(name || "").trim().toLowerCase() === normalizedOptionName
  );

  if (optionIndex !== -1 && Array.isArray(variant.options)) {
    return String(variant.options[optionIndex] || "").trim();
  }

  if (normalizedOptionName === "color" || normalizedOptionName === "colour") {
    return String(variant.option1 || variant.options?.[0] || "").trim();
  }

  if (normalizedOptionName === "size") {
    const option2Name = String(optionNames[1] || "").trim().toLowerCase();
    const option3Name = String(optionNames[2] || "").trim().toLowerCase();

    if (option2Name === "size") return String(variant.option2 || variant.options?.[1] || "").trim();
    if (option3Name === "size") return String(variant.option3 || variant.options?.[2] || "").trim();
  }

  return "";
};

const getActiveVariantSelection = (form) => {
  const idEl = form?.querySelector('[name="id"]');
  const id = idEl ? String(idEl.value || "") : "";
  const variants = getProductVariants();
  const variant = variants.find((item) => String(item.id) === id);
  const checkedColorInput = form?.querySelector('input[option="Color"]:checked, input[option="Colour"]:checked');
  const checkedSizeInput = form?.querySelector('input[option="Size"]:checked');

  return {
    color:
      getVariantOptionValue(variant, "color") ||
      getVariantOptionValue(variant, "colour") ||
      String(checkedColorInput?.value || "").trim(),
    size:
      getVariantOptionValue(variant, "size") ||
      String(checkedSizeInput?.value || "").trim(),
  };
};

const getBlendWrapMatchState = (wrap, color, size) => {
  const source = String(wrap.dataset.blendSource || "metaobject").trim().toLowerCase();
  const singleColor = (wrap.dataset.blendColor || "").trim().toLowerCase();
  const colorsRaw = (wrap.dataset.blendColors || "").trim().toLowerCase();
  const blendSize = (wrap.dataset.blendSize || "").trim().toLowerCase();
  const text = (wrap.dataset.blendText || "").trim();
  const colors = singleColor
    ? [singleColor]
    : colorsRaw
        .split(",")
        .map((c) => c.trim())
        .filter(Boolean);

  return {
    source,
    text,
    blendSize,
    hasSpecificSize: Boolean(blendSize),
    shouldShow:
      !!text &&
      colors.length > 0 &&
      colors.includes(color) &&
      (!blendSize || blendSize === size),
  };
};

const toggleBlendWrapsGlobal = (activeColor, activeSize = "") => {
  const color = (activeColor || "").trim().toLowerCase();
  const size = (activeSize || "").trim().toLowerCase();
  const wraps = document.querySelectorAll("[data-blend-wrap]");
  const hasSpecificCustomDetailsMatch = Array.from(wraps).some((wrap) => {
    const matchState = getBlendWrapMatchState(wrap, color, size);
    return matchState.source === "custom-details" && matchState.hasSpecificSize && matchState.shouldShow;
  });

  wraps.forEach((wrap) => {
    const matchState = getBlendWrapMatchState(wrap, color, size);
    const shouldShow =
      matchState.shouldShow &&
      !(
        hasSpecificCustomDetailsMatch &&
        matchState.source === "custom-details" &&
        !matchState.hasSpecificSize
      );

    wrap.style.setProperty("display", shouldShow ? "flex" : "none", "");

    wrap.querySelectorAll(".product-form__blend").forEach((el) => {
      el.textContent = shouldShow ? matchState.text : "";
    });
  });
};

const syncBlendWraps = () => {
  const form = document.querySelector(".product-form:not(.multi-add)");
  if (!form) return;
  const { color, size } = getActiveVariantSelection(form);
  toggleBlendWrapsGlobal(color, size);
};

document.addEventListener("DOMContentLoaded", () => {
  syncBlendWraps();
  requestAnimationFrame(syncBlendWraps);
  setTimeout(syncBlendWraps, 150);

  document.addEventListener("change", (e) => {
    if (!e.target.closest('.product-form [name="id"]')) return;
    syncBlendWraps();
    requestAnimationFrame(syncBlendWraps);
    setTimeout(syncBlendWraps, 150);
  });
});




const setCheckedRadioInput = function (input) {
  if (!input) return;

  const optionGroup = input.closest(".js-product-form-option");
  if (!optionGroup) return;

  optionGroup.querySelectorAll('input[type="radio"]').forEach((radio) => {
    const isTarget = radio === input;
    radio.checked = isTarget;

    if (isTarget) {
      radio.setAttribute("checked", "");
    } else {
      radio.removeAttribute("checked");
    }
  });
};

const autoSelectFirstAvailableSizeAndThirdOnLoad = function (form) {
  if (form.classList.contains("product-form--bundle-builder")) return null;

  const variantRadios = form.querySelector("variant-radios");
  if (!variantRadios) return null;

  const sizeInputs = Array.from(form.querySelectorAll('input[option="Size"]'));
  let thirdInputs = Array.from(form.querySelectorAll('input[option="Inseam"]'));
  if (thirdInputs.length === 0) {
    thirdInputs = Array.from(form.querySelectorAll('input[option="Length"]'));
  }

  if (!sizeInputs.length || !thirdInputs.length) return null;

  const hasExplicitVariantParam = new URLSearchParams(window.location.search).has("variant");
  const selectedColorInput = variantRadios.querySelector(
    'input[option="Color"]:checked, input[option="Colour"]:checked'
  );
  const selectedColor = selectedColorInput?.value;
  const currentVariantId = String(
    form.querySelector('input[name="id"]')?.value || ""
  );
  const variantData = variantRadios.getVariantJSON();
  const availableVariants = variantData.filter((variant) => variant.available);

  const currentVariant = availableVariants.find(
    (variant) => String(variant.id) === currentVariantId
  );
  const firstAvailableVariantForColor = availableVariants.find((variant) => {
    if (selectedColor && variant.option1 !== selectedColor) return false;
    return variant.option2 && variant.option3;
  });
  const firstAvailableVariant = firstAvailableVariantForColor
    || availableVariants.find((variant) => variant.option2 && variant.option3);
  const targetVariant = hasExplicitVariantParam && currentVariant
    ? currentVariant
    : firstAvailableVariant;

  if (!targetVariant?.option2 || !targetVariant?.option3) return null;

  const sizeInput = sizeInputs.find(
    (input) => input.value === targetVariant.option2
  );
  const thirdInput = thirdInputs.find(
    (input) => input.value === targetVariant.option3
  );

  if (!sizeInput || !thirdInput) return null;

  setCheckedRadioInput(sizeInput);
  setCheckedRadioInput(thirdInput);

  form.classList.add("product-form--size-selected", "product-info-updated");

  variantRadios.getSelectedOptions();
  variantRadios.getSelectedVariant();

  if (!variantRadios.currentVariant) return targetVariant;

  variantRadios.updateURL();
  variantRadios.updateFormID();
  variantRadios.updateSavingsLabel();

  if (String(variantRadios.currentVariant.id) !== currentVariantId) {
    variantRadios.updateProductInfo({ target: sizeInput });
  }

  return variantRadios.currentVariant;
};

const checkAvailableOptionsOnLoad = function () {
  const forms = document.querySelectorAll(".product-form:not(.multi-add)");

  forms.forEach((form) => {
    autoSelectFirstAvailableSizeAndThirdOnLoad(form);

    const productHandle = form.getAttribute("data-handle");
    const url = `/products/${productHandle}.js`;
    const selectedColor = form.querySelector(".option-heading__current-color");
    let selectedColorVariants = [];
    let thirdInputs = form.querySelectorAll('input[option="Inseam"]');
    if (thirdInputs.length === 0) {
      thirdInputs = form.querySelectorAll('input[option="Length"]');
    }
    const sizeInputs = form.querySelectorAll('input[option="Size"]');
    const notifyMeLink = document.querySelector(".info__notify-me");

    if (!selectedColor) return;

    const activeSelection = getActiveVariantSelection(form);
    toggleBlendWrapsGlobal(activeSelection.color, activeSelection.size);

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        data.variants.forEach((variant) => {
          if (variant.option1 === selectedColor.textContent) selectedColorVariants.push(variant);
        });

        selectedColorVariants.forEach((variant) => {
          if (!variant.available) {
            if (variant.option2 && !variant.option3) {
              sizeInputs.forEach((input) => {
                if (variant.option2 === input.value) input.classList.add("disabled");
              });
            }

            if (variant.option2 && variant.option3)
              checkSizesAndThirdOnLoad(sizeInputs, thirdInputs, variant, selectedColorVariants);
          }
        });

        let isBundleBuilder = form.classList.contains("product-form--bundle-builder") ? true : false;
        if (!isBundleBuilder && notifyMeLink) {
          let hideNotifyMe = false;

          if (notifyMeLink) {
            const currentColor = selectedColor.innerHTML.trim().toLowerCase();
            if (isBisDisabledColor(currentColor, form)) hideNotifyMe = true;
          }

          if (hideNotifyMe) {
            notifyMeLink.classList.remove("active");
          } else if (!hideNotifyMe && selectedColorVariants.some((variant) => !variant.available)) {
            notifyMeLink.classList.add("active");
          }
        }
      });
  });
};

checkAvailableOptionsOnLoad();

// ==================== End Check Unavailable options on load ====================

// ==================== Start Model Info ====================
const modelInfoMobile = function () {
  const allModelInfo = document.querySelectorAll(".model-info--mobile");
  allModelInfo.forEach((el) => {
    const modelInfoContainer = el.querySelector(".model-info-inner");
    const modelInfoTitle = el.querySelector(".model-info__title");
    const customerImagesBtns = document.querySelectorAll(
      ".customer-images-btn"
    );

    el.addEventListener("click", function () {
      // 1- Toggle Title
      modelInfoTitle.classList.toggle("hidden");

      // 2- Adjust width
      if (modelInfoTitle.classList.contains("hidden"))
        modelInfoContainer.style.display = "block";
      else modelInfoContainer.style.display = "none";

      // 3- Show/Hide Customer Image Button
      if (modelInfoTitle.classList.contains("hidden")) {
        customerImagesBtns.forEach((btn) => btn.classList.add("hidden"));
      } else {
        customerImagesBtns.forEach((btn) => btn.classList.remove("hidden"));
      }
    });
  });
};
modelInfoMobile();
// ==================== End Model Info ====================

// ==================== Start Related Bundles ====================
class RelatedBundles extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector(".related-bundles__header");
    this.allSavings = this.querySelectorAll(".bundle-option__saving");
    this.savingUpTo = this.querySelector(".related-bundles__up-to");

    this.header.addEventListener("click", this.onHeaderClick.bind(this));
    window.addEventListener("resize", this.adjustHeight.bind(this));
    document.addEventListener(
      "DOMContentLoaded",
      this.highestSavings.bind(this)
    );
  }

  onHeaderClick() {
    // 1. 'active' class
    this.classList.toggle("active");

    // 2. Open or close
    this.adjustHeight();
  }

  adjustHeight() {
    const content = this.querySelector(".related-bundles__content");
    const contentContainer = this.querySelector(
      ".related-bundles__content-container"
    );

    if (this.classList.contains("active"))
      content.style.maxHeight = getComputedStyle(contentContainer).height;
    else content.style.maxHeight = 0;
  }

  highestSavings() {
    const activeCurrency = window?.Shopify?.currency?.active;
    const runtimePrefix =
      activeCurrency === "CAD" ? "C$" : activeCurrency === "AUD" ? "A$" : "";

    if (runtimePrefix) {
      this.allSavings.forEach((saving) => {
        saving.textContent = saving.textContent.replace(
          /(^|[^A-Za-z])\$/g,
          `$1${runtimePrefix}`
        );
      });
    }

    const highestSavings = [...this.allSavings]
      .map((saving) => parseInt(saving.textContent.trim().match(/\d+/)[0]))
      .reduce((prev, cur) => (prev > cur ? prev : cur));

    const defaultCurrency = this.savingUpTo.dataset.currency || "$";
    const currency = runtimePrefix || defaultCurrency;
    this.savingUpTo.textContent = `Save up to ${currency}${highestSavings}`;
  }
}

customElements.define("related-bundles", RelatedBundles);
// ==================== End Related Bundles ====================

// ==================== Start Product Tabs ====================
const productTabsFunction = function () {
  const productTabs = document.querySelectorAll(".product-tab");
  const productTabsHeadings = document.querySelectorAll(
    ".product-tab__heading"
  );

  productTabsHeadings.forEach((heading) => {
    heading.addEventListener("click", function () {
      const thisTab = heading.closest(".product-tab");
      const wasActive = thisTab.classList.contains("active");
      const productTabContainer = thisTab.querySelector(
        ".product-tab__content-container"
      );
      const productTabHeight = getComputedStyle(
        productTabContainer.querySelector(".product-tab__content")
      ).height;

      // 1) Active class
      if (thisTab.classList.contains("active")) {
        thisTab.classList.remove("active");
      } else {
        productTabs.forEach((el) => el.classList.remove("active"));
        thisTab.classList.add("active");
      }

      // 2) Content Animation
      if (thisTab.classList.contains("active")) {
        // Close all Tabs
        productTabs.forEach(
          (el) =>
            (el.querySelector(
              ".product-tab__content-container"
            ).style.maxHeight = 0)
        );
        // Open this tab
        productTabContainer.style.maxHeight = productTabHeight;
      } else {
        // Close this tab
        productTabContainer.style.maxHeight = 0;
      }

      const isEligibleWoolmarkTab =
        thisTab.dataset.abWoolmarkEligible === "true";

      const isFirstDetailsOpen =
        thisTab.classList.contains("tab-the-details") &&
        isEligibleWoolmarkTab &&
        wasActive === false &&
        thisTab.classList.contains("active") &&
        thisTab.dataset.abOpened !== "true";

      if (isFirstDetailsOpen) {
        thisTab.dataset.abOpened = "true";

        const detail = {
          productHandle: thisTab.dataset.productHandle || "",
          sectionId: thisTab.dataset.sectionId || "",
          tab: "fabric-and-details",
          woolmarkEligible: thisTab.dataset.abWoolmarkEligible || "false",
        };

        document.dispatchEvent(
          new CustomEvent("unbound:fabric-details-opened", { detail })
        );

        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: "unbound_fabric_details_opened",
            ...detail,
          });
        }
      }
    });
  });
};

const adjustActiveProductTabHeight = function () {
  const productTabs = [...document.querySelectorAll(".product-tab")];
  const [activeProductTab] = productTabs.filter((tab) =>
    tab.classList.contains("active")
  );
  if (!activeProductTab) return;
  const activeProductTabContainer = activeProductTab.querySelector(
    ".product-tab__content-container"
  );
  const activeProductTabHeight = getComputedStyle(
    activeProductTabContainer.querySelector(".product-tab__content")
  ).height;

  activeProductTabContainer.style.maxHeight = activeProductTabHeight;
};

// Adjust Features tab Height on load
const adjustFeaturesTabHeightOnLoad = function () {
  const featuredTabContainer = document.querySelector(
    ".tab-features .product-tab__content-container"
  );
  if (!featuredTabContainer) return;
  const featuredTabHeight = getComputedStyle(
    featuredTabContainer.querySelector(".product-tab__content")
  ).height;

  featuredTabContainer.style.maxHeight = featuredTabHeight;
};

// The Fit
const checkTheFitContent = function () {
  const theFit = document.querySelector(".tab-the-fit");
  const theFitContent = theFit.querySelector(".product-tab__content");

  if (theFitContent.textContent.trim()) theFit.classList.remove("hidden");
};

productTabsFunction();
adjustFeaturesTabHeightOnLoad();
checkTheFitContent();
adjustActiveProductTabHeight();
// ==================== End Product Tabs ====================

// ==================== Start Learn More Scroll ====================
const learnMoreFunction = function () {
  const descriptionLearnMore = document.querySelector(
    ".product-description--learn-more"
  );
  if (!descriptionLearnMore) return;

  descriptionLearnMore.addEventListener("click", function () {
    const headerHeight = parseInt(
      getComputedStyle(document.querySelector(".mega-sticky-header")).height
    );
    const productNavHeight = document.querySelector(".sticky-product-nav")
      ? parseInt(
          getComputedStyle(document.querySelector(".sticky-product-nav")).height
        )
      : 0;
    const topOffset = headerHeight + productNavHeight;

    const benefitsSection = document.querySelector(".why-unbound-merino");
    const mixedBundlesSection = document.querySelector(".mixed-bundles");
    const iconWoolSection = document.querySelector("#product-wool-icons");
    const videoSectionInner = document.querySelector(".video-section__inner");

    let target = null;
    if (benefitsSection) {
      target = benefitsSection;
    } else if (mixedBundlesSection) {
      target = mixedBundlesSection;
    } else if (iconWoolSection) {
      target = iconWoolSection;
    } else if (videoSectionInner) {
      target = videoSectionInner;
    }

    if (target) {
      window.scrollTo({
        top: target.offsetTop - topOffset,
        behavior: "smooth"
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", learnMoreFunction);

// ==================== End Learn More Scroll ====================

// ==================== Start Preorder Function ====================
const preorderFunction = function () {
  const preorderBtn = document.querySelector(".pre-order-button");
  const preorderAddToCartBtn = document.querySelector(
    ".preorder-confirmation__add-to-cart"
  );
  const preorderPopup = document.querySelector(".preorder-confirmation");
  const preorderClose = document.querySelector(".preorder-confirmation__close");

  if (!preorderBtn) return;

  const openPreorderConfirmation = function () {
    preorderPopup.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  };

  const closePreorderConfirmation = function () {
    preorderPopup.classList.add("hidden");
    document.body.style.overflow = "auto";
  };

  // Open
  preorderBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openPreorderConfirmation();
  });

  // Close
  preorderClose.addEventListener("click", closePreorderConfirmation);
  preorderPopup.addEventListener("click", function (e) {
    if (e.target === this) closePreorderConfirmation();
  });
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePreorderConfirmation();
  });

  // Add to cart
  preorderAddToCartBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closePreorderConfirmation();
    updateCart();
  });
};

document.addEventListener("DOMContentLoaded", preorderFunction);
// ==================== End Preorder Function ====================

// ==================== Start Image Zoom ====================
const featuredImagesZoom = function () {
  const mainProduct = document.querySelector("#main-product");
  const disableZoom = mainProduct?.dataset.disableZoom === "true";
  if (disableZoom) return;

  // Drift settings for non touch screens
  const driftImgs = [...document.querySelectorAll(".drift-img")];
  if (matchMedia("(hover: hover)").matches) {
    driftImgs.forEach((img) => {
      const pane = img.closest(".keen-slider__slide");
      new Drift(img, {
        paneContainer: pane,
        zoomFactor: 4,
        inlinePane: false,
      });
    });
  }

  // Zoom functionality
  // A) Non touch Screens - Drift
  const featuredImages = document.querySelectorAll(
    ".product-media__gallery .media-container.type-image"
  );
  featuredImages.forEach((img) => {
    img.addEventListener("click", function () {
      const touch = matchMedia("(hover: none)").matches;
      if (!touch) img.classList.toggle("zoom-active");
    });

    // Show Tip for touch screens
    img.addEventListener("touchstart", function () {
      const touchScreenZoomTips = document.querySelectorAll(
        ".touch-screen-tool-tip"
      );

      touchScreenZoomTips.forEach((el) => {
        el.style.display = "block";
        el.classList.add("active-animation");

        setTimeout(() => {
          el.style.display = "none";
          el.classList.remove("active-animation");
        }, 5000);

        img.addEventListener("touchmove", function () {
          el.style.display = "none";
          el.classList.remove("active-animation");
        });
      });
    });
  });

  // B) Touch screens - Pinch
  const pinchZoomWrappers = document.querySelectorAll(".pinch-zoom");
  pinchZoomWrappers.forEach((el) => {
    let pz = new PinchZoom(el, {
      tapZoomFactor: 3,
      minZoom: 0.9,
      draggableUnzoomed: false,
      onZoomStart: function () {
        const touchScreenZoomTips = document.querySelectorAll(
          ".touch-screen-tool-tip"
        );
        touchScreenZoomTips.forEach((el) => el.classList.add("hidden"));
      },
      onDoubleTap: function () {
        const touchScreenZoomTips = document.querySelectorAll(
          ".touch-screen-tool-tip"
        );
        touchScreenZoomTips.forEach((el) => el.classList.add("hidden"));
      },
    });
  });

  // Fix for Samsung devices: Allow vertical scrolling while preserving horizontal swiping and pinch-to-zoom
  // More aggressive solution using CSS touch-action and early event interception
  
  // Android device detection that works in BrowserStack and other testing environments
  function isAndroidDevice() {
    // Check user agent for Android devices (includes Samsung, etc.)
    const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
    const androidRegex = /android/i;
    
    // Also check for Android in the platform if available
    if (navigator.platform) {
      const platform = navigator.platform.toLowerCase();
      if (platform.includes('android')) return true; 
    }
    
    // Primary check: user agent
    if (androidRegex.test(userAgent)) return true;
    
    return false;
  }
  
  if (isAndroidDevice()) {
    const gallery = document.querySelector(".product-media__gallery--slider");
    const pinchZoomParents = document.querySelectorAll(".pinch-zoom-parent");
    const pinchZoomElements = document.querySelectorAll(".pinch-zoom");
    
    // Apply CSS touch-action to allow vertical scrolling and pinch-zoom
    // This tells the browser to allow these gestures natively
    if (gallery) {
      gallery.style.touchAction = 'pan-y pinch-zoom';
    }
    pinchZoomParents.forEach((el) => {
      el.style.touchAction = 'pan-y pinch-zoom';
    });
    pinchZoomElements.forEach((el) => {
      el.style.touchAction = 'pan-y pinch-zoom';
    });
    
    // Store touch state per element to handle multiple simultaneous touches
    const touchStateMap = new WeakMap();
    const handlerMap = new WeakMap();
    
    function getTouchState(el) {
      if (!touchStateMap.has(el)) {
        touchStateMap.set(el, {
          touchStartX: 0,
          touchStartY: 0,
          touchStartTime: 0,
          isVerticalScroll: false,
          isHorizontalSwipe: false,
          touchMoved: false,
          touchCount: 0,
          lastTouchX: 0,
          lastTouchY: 0
        });
      }
      return touchStateMap.get(el);
    }

    function createTouchHandlers(element) {
      // Check if handlers are already attached
      if (handlerMap.has(element)) return;
      handlerMap.set(element, true);
      
      const touchStartHandler = function (e) {
        const state = getTouchState(element);
        state.touchCount = e.touches.length;
        
        if (state.touchCount === 1) {
          state.touchStartX = e.touches[0].clientX;
          state.touchStartY = e.touches[0].clientY;
          state.lastTouchX = state.touchStartX;
          state.lastTouchY = state.touchStartY;
          state.touchStartTime = Date.now();
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          state.touchMoved = false;
        } else if (state.touchCount === 2) {
          // Pinch gesture - let PinchZoom handle it
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          state.touchMoved = false;
        }
      };

      const touchMoveHandler = function (e) {
        const state = getTouchState(element);
        
        // Handle pinch gestures (2 touches) - let PinchZoom handle it
        if (state.touchCount === 2 || e.touches.length === 2) {
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          return; // Let PinchZoom handle it
        }
        
        // Handle single touch
        if (state.touchCount === 1 && e.touches.length === 1) {
          const currentX = e.touches[0].clientX;
          const currentY = e.touches[0].clientY;
          const deltaX = currentX - state.touchStartX;
          const deltaY = currentY - state.touchStartY;
          const absDeltaX = Math.abs(deltaX);
          const absDeltaY = Math.abs(deltaY);
          
          // Calculate movement since last touch event
          const moveX = currentX - state.lastTouchX;
          const moveY = currentY - state.lastTouchY;
          state.lastTouchX = currentX;
          state.lastTouchY = currentY;

          // Determine direction after initial movement (lower threshold for faster detection)
          if (!state.touchMoved && (absDeltaX > 5 || absDeltaY > 5)) {
            state.touchMoved = true;
            
            // More lenient detection - prioritize vertical scrolling
            if (absDeltaY > absDeltaX * 1.2 && absDeltaY > 10) {
              // Primarily vertical - allow page scroll
              state.isVerticalScroll = true;
              state.isHorizontalSwipe = false;
            } else if (absDeltaX > absDeltaY * 1.5 && absDeltaX > 15) {
              // Primarily horizontal - let slider handle it
              state.isVerticalScroll = false;
              state.isHorizontalSwipe = true;
            }
          } else if (state.touchMoved) {
            // Update direction based on continued movement
            if (absDeltaY > absDeltaX * 1.2) {
              state.isVerticalScroll = true;
              state.isHorizontalSwipe = false;
            } else if (absDeltaX > absDeltaY * 1.5) {
              state.isVerticalScroll = false;
              state.isHorizontalSwipe = true;
            }
          }

          // If it's a vertical scroll, manually scroll the page
          if (state.isVerticalScroll && !state.isHorizontalSwipe) {
            // Manually scroll the window based on touch movement - this bypasses all event blocking
            // Use a multiplier to make scrolling feel more natural (native scroll feels more responsive)
            if (Math.abs(moveY) > 0) {
              const scrollMultiplier = 14; // Multiplier to match natural scroll feel
              window.scrollBy({
                top: -moveY * scrollMultiplier, // Negative because touch Y increases downward but scroll should go up
                behavior: 'auto'
              });
            }
            
            // Prevent default and stop propagation to prevent libraries from interfering
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            return false;
          }
        }
      };

      const touchEndHandler = function (e) {
        const state = getTouchState(element);
        // Reset flags after a delay
        setTimeout(() => {
          state.touchMoved = false;
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          state.touchCount = 0;
          state.lastTouchX = 0;
          state.lastTouchY = 0;
        }, 100);
      };

      // Store handlers for potential cleanup
      element._samsungScrollFix = {
        touchstart: touchStartHandler,
        touchmove: touchMoveHandler,
        touchend: touchEndHandler
      };

      // Use capture phase to intercept before other handlers
      element.addEventListener("touchstart", touchStartHandler, { passive: true, capture: true });
      element.addEventListener("touchmove", touchMoveHandler, { passive: false, capture: true });
      element.addEventListener("touchend", touchEndHandler, { passive: true, capture: true });
    }

    // Add handlers to gallery, pinch-zoom parents, and pinch-zoom elements
    const elementsToHandle = gallery 
      ? [gallery, ...Array.from(pinchZoomParents), ...Array.from(pinchZoomElements)]
      : [...Array.from(pinchZoomParents), ...Array.from(pinchZoomElements)];
    
    elementsToHandle.forEach((element) => {
      if (!element) return;
      createTouchHandlers(element);
    });
  }
};
document.addEventListener("DOMContentLoaded", featuredImagesZoom);
// ==================== End Image Zoom ====================


// ==================== Sticky ATC ========================
function initStickyAddToCart() {
  const isVisible = (el) => {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || el.classList.contains("hidden")) return false;
    const r = el.getClientRects();
    return r && r.length > 0;
  };

  const bundleBuilderBtn = document.querySelector(".bundle-builder-add-to-cart");
  const packAddToCartBtn = document.querySelector(".pack-add-to-cart");
  const packChooseProductsBtn = document.querySelector(".pack-choose-products");
  const activePackBtn = [packAddToCartBtn, packChooseProductsBtn].find((el) => isVisible(el));
  const regularCTA = Array.from(
    document.querySelectorAll(
      "#main-product .product-form:not(.product-form--pack):not(.product-form--bundle-builder) .product-form__cta"
    )
  ).find((el) => isVisible(el));
  const isPackProduct = !!activePackBtn;
  const isBundleBuilder = !isPackProduct && isVisible(bundleBuilderBtn);
  const originalCTA = isPackProduct
    ? activePackBtn.closest(".packs-product-form") || activePackBtn.parentElement || activePackBtn
    : isBundleBuilder
      ? bundleBuilderBtn.closest(".bundle-builder") || bundleBuilderBtn.parentElement || bundleBuilderBtn
      : regularCTA;

  if (!originalCTA) return;

  document.querySelectorAll(".sticky-cta-clone").forEach(el => el.remove());

  const stickyCTA = document.createElement("div");
  stickyCTA.className = "product-form__cta sticky-cta-clone";
  document.body.appendChild(stickyCTA);

  const header = document.querySelector(".site-header, .header, .shopify-section-header");
  const okeReview = document.querySelector(".oke-fit-review");
  const pillsNav = document.querySelector(".feature-pills__nav");
  const isBackpack = !isPackProduct && !isBundleBuilder && document.body.classList.contains("product-backpack");

  const getPrimaryBtn = () => {
    if (isPackProduct) {
      const packBtn = [packAddToCartBtn, packChooseProductsBtn].find((el) => isVisible(el));
      if (packBtn) return { el: packBtn, type: "pack", text: packBtn.textContent.trim() };
    }

    // Bundle builder: use the bundle builder ATC button directly
    if (isBundleBuilder) {
      return { el: bundleBuilderBtn, type: "bundle", text: bundleBuilderBtn.textContent.trim() };
    }

    const scope = originalCTA.querySelector(".size-selected") || originalCTA;
    const klaviyo = scope.querySelector(".js-klaviyo-bis-proxy");
    if (isVisible(klaviyo)) return { el: klaviyo, type: "klaviyo", text: klaviyo.textContent.trim() };

    const preorder = scope.querySelector(".pre-order-button");
    if (isVisible(preorder)) return { el: preorder, type: "preorder", text: preorder.textContent.trim() };

    const atc = scope.querySelector(".add-to-cart-button");
    if (isVisible(atc)) return { el: atc, type: "atc", text: atc.textContent.trim() };

    const sold = scope.querySelector(".sold-out-button");
    if (isVisible(sold)) return { el: sold, type: "soldout", text: sold.textContent.trim() };

    const selectSizeBtn = originalCTA.querySelector(".select-size-button");
    if (selectSizeBtn) {
      const spanAdd = selectSizeBtn.querySelector(".select-size-button__add-to-cart");
      const spanSelect = selectSizeBtn.querySelector(".select-size-button__select-a-size");
      let text = "";
      if (spanAdd && getComputedStyle(spanAdd).display !== "none") text = spanAdd.textContent.trim();
      else if (spanSelect && getComputedStyle(spanSelect).display !== "none") text = spanSelect.textContent.trim();
      else text = selectSizeBtn.textContent.trim();
      return { el: selectSizeBtn, type: "select", text };
    }

    return null;
  };

  // Scrolls so the main CTA/product form sits near the bottom of the viewport
  // (instead of the browser's default focus-into-view, which centers it).
  const scrollToMainCtaNearBottom = (targetEl, onDone) => {
    if (!targetEl) {
      if (onDone) onDone();
      return;
    }
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const bottomMargin = stickyCTA.offsetHeight || 0;
    const rect = targetEl.getBoundingClientRect();
    const y = rect.bottom + window.scrollY - vh + bottomMargin + 20;

    if (onDone) {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        onDone();
      };
      let lastY = window.scrollY;
      const checkStopped = () => {
        if (settled) return;
        if (Math.abs(window.scrollY - lastY) < 1) {
          finish();
          return;
        }
        lastY = window.scrollY;
        requestAnimationFrame(checkStopped);
      };
      requestAnimationFrame(checkStopped);
      setTimeout(finish, 500);
    }

    window.scrollTo({ top: Math.max(y, 0), behavior: "smooth" });
  };

  const scrollTopSmooth = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const inViewportByRatio = (el, minRatio = 0.01) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const intersect = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    const visible = intersect > 0;
    const ratio = rect.height > 0 ? intersect / rect.height : 0;
    return visible && ratio >= minRatio;
  };

  let lastSignature = "";

  const renderSticky = () => {
    const primary = getPrimaryBtn();
    if (!primary) return;
    const isDisabled = primary.el?.classList?.contains("disabled");
    const signature = primary.type + "|" + primary.text + "|" + isDisabled;
    if (signature === lastSignature && stickyCTA.querySelector("button")) return;
    lastSignature = signature;
    stickyCTA.innerHTML = "";
    const btn = document.createElement("button");
    btn.className = "btn-cta btn--black sticky-cta-btn";
    if (isDisabled) btn.classList.add("disabled");
    btn.textContent = primary.text;
    stickyCTA.appendChild(btn);
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const current = getPrimaryBtn();
      if (!current) return;

      // Always scroll first so the main CTA/product form lands near the
      // bottom of the viewport (not centered), keeping the form/options visible.
      scrollToMainCtaNearBottom(originalCTA, () => {
        const latest = getPrimaryBtn();
        if (!latest) return;

        if (latest.type === "pack") {
          if (latest.el !== packChooseProductsBtn) latest.el.click();
          return;
        }

        if (latest.type === "bundle") {
          if (!latest.el.classList.contains("disabled")) latest.el.click();
          return;
        }

        if (latest.type === "select" || latest.type === "soldout") {
          return;
        }

        if (latest.type === "preorder" || latest.type === "atc" || latest.type === "klaviyo") {
          if (!latest.el.classList.contains("disabled")) latest.el.click();
        }
      });
    });
  };

  const toggleStickyCTA = () => {
    if (window.innerWidth >= 750) {
      stickyCTA.classList.remove("is-sticky");
      return;
    }

    // Never show on page load before scroll
    if (window.scrollY < 1) {
      stickyCTA.classList.remove("is-sticky");
      return;
    }

    const primary = getPrimaryBtn();
    const mainVisible = inViewportByRatio(primary?.el || originalCTA, 0.01);

    let triggerReached = false;
    if (isPackProduct || isBundleBuilder) {
      // For pack/bundle builders, rely on the main CTA visibility itself.
      triggerReached = true;
    } else if (isBackpack && pillsNav) {
      const rect = pillsNav.getBoundingClientRect();
      triggerReached = rect.top <= window.innerHeight;
    } else if (!isBackpack && okeReview) {
      const rect = okeReview.getBoundingClientRect();
      triggerReached = rect.top <= window.innerHeight;
    }

    const shouldShow = triggerReached && !mainVisible;
    stickyCTA.classList.toggle("is-sticky", shouldShow);
  };

  const observer = new MutationObserver(() => {
    renderSticky();
    toggleStickyCTA();
  });
  observer.observe(originalCTA, { childList: true, subtree: true, attributes: true, characterData: true });
  // Also watch pack/bundle CTAs for text/disabled state changes
  [packAddToCartBtn, packChooseProductsBtn].forEach((btn) => {
    if (btn) observer.observe(btn, { childList: true, subtree: true, attributes: true, characterData: true });
  });
  if (isBundleBuilder) {
    observer.observe(bundleBuilderBtn, { childList: true, subtree: true, attributes: true, characterData: true });
  }

  setInterval(renderSticky, 400);

  window.addEventListener("scroll", toggleStickyCTA, { passive: true });
  window.addEventListener("resize", toggleStickyCTA);

  renderSticky();
  toggleStickyCTA();
}

initStickyAddToCart();

// ==================== End Sticky Add to Cart Button ====================

// ==================== Start Shipping & Returns Modal ====================
// Open & Close Shipping & Returns Modal
const shippingReturnsBtns = document.querySelectorAll(".shipping-tab");

const shippingReturnsFunction = function () {
  if (shippingReturnsBtns.length < 1) return;
  const shippingReturnsPopup = document.querySelector(
    ".shipping-returns-popup"
  );
  const shippingReturnsClose = document.querySelector(
    ".shipping-returns-popup__close"
  );

const openSizeGuideModal = function () {
  shippingReturnsPopup.classList.remove("hidden");
  document.body.style.overflow = "hidden";

  const container = shippingReturnsPopup.querySelector(
    ".shipping-returns-popup__container"
  );

  if (!container) return;

  requestAnimationFrame(() => {
    container.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
};



  const closeSizeGuideModal = function () {
    shippingReturnsPopup.classList.add("hidden");
    document.body.style.overflow = "";
  };

  const openReturnsModal = function(){
    setTimeout(() => {
    let returnsExchanges = document.querySelector('.returns__container');
    if (returnsExchanges) {
      returnsExchanges.scrollIntoView({ behavior: "smooth" });
    }
  }, 100);
  }

  let returnsModal = document.querySelector('.shipping-tab--returns');

  returnsModal.addEventListener("click", openReturnsModal);



  // Open Size Guide
  shippingReturnsBtns.forEach((btn) =>
    btn.addEventListener("click", openSizeGuideModal)
  );

  // Close Fit
  shippingReturnsClose.addEventListener("click", closeSizeGuideModal);
  shippingReturnsPopup.addEventListener("click", function (e) {
    if (e.target === this) closeSizeGuideModal();
  });
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeSizeGuideModal();
  });
};

document.addEventListener("DOMContentLoaded", shippingReturnsFunction);
// ==================== End Shipping & Returns Modal ====================

// ==================== Start hide BIS hidden options ====================
const hasCustomBisModal = function () {
  return !!document.getElementById("ub-bis-overlay");
};

const getPersistentKlaviyoBisTrigger = function () {
  return document.querySelector(".js-klaviyo-bis-persistent.klaviyo-bis-trigger");
};

const openPersistentKlaviyoBisTrigger = function (attempt = 0) {
  if (hasCustomBisModal()) return;
  const trigger = getPersistentKlaviyoBisTrigger();
  if (!trigger) return;
  if (document.querySelector("#klaviyo-bis-iframe")) return;

  if (typeof window.queueKlaviyoBackInStockInit === "function") {
    window.queueKlaviyoBackInStockInit(0);
  } else if (typeof window.initializeKlaviyoBackInStock === "function") {
    window.initializeKlaviyoBackInStock();
  }

  trigger.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );

  if (attempt >= 6) return;

  window.setTimeout(() => {
    if (document.querySelector("#klaviyo-bis-iframe")) return;
    openPersistentKlaviyoBisTrigger(attempt + 1);
  }, 250);
};

const filterKlaviyoBisOptions = function () {
  if (hasCustomBisModal()) return;
  setTimeout(() => {
    const iframe = document.querySelector("#klaviyo-bis-iframe");
    if (!iframe) return;

    try {
      const doc = iframe.contentDocument
        ? iframe.contentDocument
        : iframe.contentWindow
        ? iframe.contentWindow.document
        : iframe.document;
      if (!doc) return;

      const options = Array.from(
        doc.querySelectorAll("#klaviyo-bis-modal select option")
      );
      if (options.length < 1) return;

      options.forEach((option) => {
        if (option.textContent.includes("_")) option.remove();
      });

      const colors = Array.from(
        new Set([...getDiscontinuedColors(), ...getLastChanceColors()])
      );
      if (colors.length) {
        Array.from(
          doc.querySelectorAll("#klaviyo-bis-modal select option")
        ).forEach((option) => {
          const optionText = option.text.toLowerCase();
          const discontinuedOption = colors.some((color) =>
            optionText.includes(color)
          );
          if (discontinuedOption) option.remove();
        });
      }
    } catch (error) {
      console.warn("Klaviyo BIS options filtering skipped.", error);
    }
  }, 500);
};

const bindKlaviyoBisProxyButtons = function () {
  // no-op: handled via delegation below
};

document.body.addEventListener("click", function (event) {
  if (hasCustomBisModal()) return;
  const btn = event.target.closest(".js-klaviyo-bis-proxy");
  if (!btn) return;
  event.preventDefault();
  openPersistentKlaviyoBisTrigger(0);
  filterKlaviyoBisOptions();
});

const hideBIShiddenOptions = function () {
  if (hasCustomBisModal()) return;
  const bisBtns = document.querySelectorAll(".klaviyo-bis-trigger");
  if (bisBtns.length < 1) return;

  bisBtns.forEach((btn) => {
    if (btn.dataset.klaviyoBisOptionsBound === "true") return;

    btn.dataset.klaviyoBisOptionsBound = "true";
    btn.addEventListener("click", function () {
      filterKlaviyoBisOptions();
    });
  });
};

document.addEventListener("DOMContentLoaded", bindKlaviyoBisProxyButtons);
document.addEventListener("DOMContentLoaded", hideBIShiddenOptions);
// ==================== End hide BIS hidden options ====================

// ==================== Start variant fulfil state BIS filter ====================
// Hide BIS when variant_fulfil_state is "phasing out" or "discontinued"; show otherwise.
const applyRestockDateBisFilter = function (variantId) {
  const bisButtons = document.querySelectorAll(".js-restock-date-bis");
  if (!bisButtons.length) return;

  const fulfilStates = window.variantFulfilStates || {};
  const state = (fulfilStates[String(variantId)] || "").toLowerCase().trim();

  const hideBis = state === "phase out" || state === "disco";

  bisButtons.forEach((btn) => {
    const bisSection = btn.closest(".product-form__bis-section");
    const soldOutBtn =
      btn.parentElement?.querySelector(".sold-out-button")
      || bisSection?.querySelector(".sold-out-button");

    btn.classList.toggle("hidden", hideBis);
    soldOutBtn?.classList.toggle("hidden", !hideBis);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) applyRestockDateBisFilter(variantInput.value);
});
// ==================== End variant fulfil state BIS filter ====================

// ==================== Start Select a size ====================
const syncSizeLabelActiveState = function (sizeLabel) {
  const optionGroup = sizeLabel?.closest(".product-form__option-size");
  if (!optionGroup) return;

  optionGroup
    .querySelectorAll(".product-form__button-label")
    .forEach((el) => el.classList.toggle("active", el === sizeLabel));
};

const allSizeLabels = document.querySelectorAll(
  ".product-form__option-size .product-form__button-label"
);

allSizeLabels.forEach((sizeLabel) => {
  sizeLabel.addEventListener("pointerdown", function () {
    syncSizeLabelActiveState(this);
  });

  sizeLabel.addEventListener("click", function () {
    syncSizeLabelActiveState(this);

    const form = this.closest(".product-form");
    const isBundleBuilder = form?.classList.contains("product-form--bundle-builder") ?? false;

    const isBlackFridayVariety =
      Array.isArray(window?.productData?.tags) &&
      window.productData.tags.includes("black-friday-variety");

    if (!isBundleBuilder) {
      const relatedInput = document.querySelector(
        `input[id="${this.getAttribute("for")}"]`
      );
      const variantRadios = document.querySelector("variant-radios");

      form.classList.add("product-form--size-selected");

      if (relatedInput?.hasAttribute("checked")) {
        variantRadios?.onVariantChange();
      }
    }

    if (isBlackFridayVariety) {
      const fixedVariantEl = document.querySelector(
        ".bundle-builder-row__selected-variant"
      );
      const combinedColors =
        window?.giftSetColors ||
        fixedVariantEl?.dataset?.fixedLabel ||
        fixedVariantEl?.textContent?.trim();

      if (fixedVariantEl && combinedColors) {
        fixedVariantEl.dataset.fixedLabel = combinedColors;
        fixedVariantEl.textContent = combinedColors;
      }
    }
  });
});


// ====== "Select a Size" Button ======
const selectASizeBtnClick = function () {
  const btn = document.querySelector(".select-size-button");
  btn?.addEventListener("click", (e) => {
    const addToCartEl = btn.querySelector(".select-size-button__add-to-cart");
    const selectASizeEl = btn.querySelector(
      ".select-size-button__select-a-size"
    );
    e.preventDefault();
    addToCartEl.style.display = "none";
    selectASizeEl.style.display = "block";
  });
};
document.addEventListener("DOMContentLoaded", selectASizeBtnClick);
// ==================== End Select a size ====================


// ==================== Start Product Dimensions ====================
const productDimensions = function () {
  const measurementsBtn = document.querySelector(".measurements-btn");
  const clothingMeasurements = document.querySelector(".clothing-measurements");
  if (!measurementsBtn) return;
  measurementsBtn.addEventListener("click", (e) => {
    e.preventDefault();

    // Open Size Guide Modal
    if (sizeGuidePopup) openSizeGuideModal(sizeGuidePopup);

    // Scroll to Clothing Measurements
    if (clothingMeasurements)
      clothingMeasurements.scrollIntoView({ behavior: "smooth" });
  });
};

// Init on load
document.addEventListener("DOMContentLoaded", productDimensions);
// ==================== End Product Dimensions ====================

// ==================== Start Customer Images Button ====================
const customerImgesFunction = function () {
  const customerImagesSection = document.querySelector("#customer-images");
  const customerImagesBtns = document.querySelectorAll(".customer-images-btn");

  if (customerImagesSection) {
    customerImagesBtns.forEach((btn) => {
      // 1- Show Customer Images Button
      btn.style.display = "block";

      // 2- Click Event, Scroll to Customer Images Section
      btn.addEventListener("click", function (e) {
        const headerHeigt = parseInt(
          getComputedStyle(document.querySelector(".mega-sticky-header")).height
        );
        const productNavHeight = parseInt(
          getComputedStyle(document.querySelector(".sticky-product-nav")).height
        );
        const topOffset = headerHeigt + productNavHeight;

        e.preventDefault();

        document.body.scrollTop =
          customerImagesSection.offsetTop - topOffset + 1;
        document.documentElement.scrollTop =
          customerImagesSection.offsetTop - topOffset + 1;
      });
    });
  }
};
// document.addEventListener('DOMContentLoaded', customerImgesFunction);
// ==================== End Customer Images Button ====================

// ==================== Start Show Tall/Petite Klaviyo Popups ====================
document
  .querySelector(".klaviyo-btn--tall-mobile")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "UujAf9"]);
  });
document
  .querySelector(".klaviyo-btn--tall-desktop")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "TL9hRu"]);
  });

document
  .querySelector(".klaviyo-btn--petite-mobile")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "RGFxX9"]);
  });
document
  .querySelector(".klaviyo-btn--petite-desktop")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "V34hTz"]);
  });

// ==================== End Show Tall/Petite Klaviyo Popups ====================

// ==================== Start Micron Chart ====================
const micronChart = function () {
  const progress = document.querySelector(".micron-chart__progress");
  const progressValue = document.querySelector(".micron-chart__progress-value");
  if (!progress) return;
  const progressWidth = parseInt(getComputedStyle(progress).width);
  const progressValueWidth = parseInt(getComputedStyle(progressValue).width);
  const remainingProgressWidth = progressWidth - progressValueWidth;
  const percentage = progressValue.dataset.percentage;
  const pxToMove = (remainingProgressWidth * percentage) / 100;

  progressValue.style.left = `${pxToMove}px`;
};

document.addEventListener("DOMContentLoaded", micronChart);
window.addEventListener("resize", micronChart);
// ==================== End Micron Chart ====================

// ==================== Start Micron Modal ====================
const micronModal = document.querySelector(".micron-modal");

const openMicronModal = (micronModal) => {
  micronModal.classList.remove("hidden");
  document.body.classList.add("micron-modal-opened");
};

const closeMicronModal = (micronModal) => {
  micronModal.classList.add("hidden");
  document.body.classList.remove("micron-modal-opened");
};

const micronModalFunction = () => {
  if (!micronModal) return;
  const iconOpen = document.querySelector(
    ".micron-list-item .icon-question-mark"
  );
  const iconClose = micronModal.querySelector(".icon-close");

  // Open
  if (iconOpen) {
    iconOpen.addEventListener("click", () => openMicronModal(micronModal));
  } else {
    console.log("iconOpen not found"); // For debugging
  }

  // Close
  iconClose.addEventListener("click", () => closeMicronModal(micronModal));
  micronModal.addEventListener("click", function (e) {
    if (e.target === this) closeMicronModal(micronModal);
  });
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMicronModal(micronModal);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (micronModal) micronModalFunction();
});
// ==================== End Micron Modal ====================

// ==================== Start singles and packs buttons ====================
const singleAndPacksBtns = function () {
  const btns = document.querySelectorAll(".singles-and-packs__btn");

  btns.forEach((btn) => {
    btn.addEventListener("click", function () {
      if (btn.classList.contains("active")) return;

      const btnBg = document.querySelector(
        ".singles-and-packs__btn-background"
      );
      const productFormContainer = document.querySelector(
        ".singles-and-packs__product-form"
      );
      const bundleBuilderContainer = document.querySelector(
        ".singles-and-packs__bundle-builder"
      );
      const savingsEls = document.querySelectorAll(
        ".singles-and-packs__savings"
      );
      const singlePrice = document.querySelectorAll(".product-price");
      const packPrice = document.querySelectorAll(".pack-price");
      const singleVariantRadiosEl = document.querySelector(
        ".singles-and-packs__product-form variant-radios"
      );

      // If packs
      if (btn.dataset.type === "packs") {
        // 1. active class
        btns.forEach((el) => el.classList.remove("active"));
        btn.classList.add("active");

        // 2. Background animation
        btnBg.classList.remove("active-singles");
        btnBg.classList.add("active-packs");

        // 3. Show bundle builder
        productFormContainer.classList.add("hidden");
        bundleBuilderContainer?.classList.remove("hidden");

        // 4. Hide savings
        savingsEls.forEach((el) => el.classList.add("visibility-hidden"));

        // 5. Show pack price
        singlePrice.forEach((price) => price.classList.add("hidden"));
        packPrice.forEach((price) => price.classList.remove("hidden"));

        requestAnimationFrame(() => syncPackSavingsBadge());
      }

      // If singels
      if (btn.dataset.type === "singles") {
        // 1. active class
        btns.forEach((el) => el.classList.remove("active"));
        btn.classList.add("active");

        // 2. Background animation
        btnBg.classList.add("active-singles");
        btnBg.classList.remove("active-packs");

        // 3. Show product form
        productFormContainer.classList.remove("hidden");
        bundleBuilderContainer?.classList.add("hidden");

        // 4. Show savings
        savingsEls.forEach((el) => el.classList.remove("visibility-hidden"));

        // 5. Show product price
        packPrice.forEach((price) => price.classList.add("hidden"));
        singlePrice.forEach((price) => price.classList.remove("hidden"));

        // 6. Update product info
        singleVariantRadiosEl.getSelectedOptions();
        singleVariantRadiosEl.getVariantJSON();
        singleVariantRadiosEl.getSelectedVariant();
        singleVariantRadiosEl.updateProductInfo();
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", singleAndPacksBtns);
// ==================== End singles and packs switch ====================
// ==================== Keep Black Friday Variety Label Fixed ====================
function keepVarietyLabelFixed() {
  const isVariety =
    Array.isArray(window?.productData?.tags) &&
    window.productData.tags.includes("black-friday-variety");
  if (!isVariety) return;

  const fixedEl = document.querySelector(".bundle-builder-row__selected-variant");
  if (!fixedEl) return;

  let fixedText = "";

  if (window?.giftSetColors) {
    fixedText = window.giftSetColors
      .split(",")
      .map((c) => c.trim())
      .join(" / ");
  } else if (fixedEl.dataset.fixedLabel) {
    fixedText = fixedEl.dataset.fixedLabel
      .split(",")
      .map((c) => c.trim())
      .join(" / ");
  } else {
    fixedText = fixedEl.textContent.trim().replace(/,/g, " / ");
  }

  if (!fixedText) return;

  fixedEl.dataset.fixedLabel = fixedText;

  const enforce = () => {
    const el = document.querySelector(".bundle-builder-row__selected-variant");
    if (el && el.textContent.trim() !== fixedText) {
      el.textContent = fixedText;
    }
  };

  const observer = new MutationObserver(enforce);
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
  });

  document.addEventListener("change", enforce);
  document.addEventListener("click", enforce);

  enforce();
}

document.addEventListener("DOMContentLoaded", keepVarietyLabelFixed);

// ==================== Hide Remove Icon + Auto-Add Rows ====================
document.addEventListener("DOMContentLoaded", () => {
  const style = document.createElement("style");
  style.textContent = `
    .bundle-builder-row__outer .icon-remove {
     
    }
  `;
  document.head.appendChild(style);

  const handle = window.location.pathname.split("/products/")[1]?.replace(/\/$/, "");

  const autoAddHandles = [
    "mens-build-your-own-5-pack",
    "women-s-build-your-own-5-pack",
    "mens-5-pack-gift-set-variety",
    "women-s-5-pack-gift-set-variety"
  ];

  if (autoAddHandles.includes(handle)) {
    const addRowBtn = document.querySelector(".bundle-builder__add-row");
    if (!addRowBtn) return;

    addRowBtn.click();

    setTimeout(() => {
      const btnAgain = document.querySelector(".bundle-builder__add-row");
      if (btnAgain) btnAgain.click();
    }, 1000);
  }
});

// ==================== Start Tall/Petite Klaviyo Popups ====================
let productHandle = document.querySelector('.main-product')?.dataset?.handle || "";

if (productHandle.includes('tall')) {
  let tallPopupSignup = document.querySelector('.vertical-popup-signup--tall');

  let alreadyShown = sessionStorage.getItem('tallPopupShown') === 'true';

  if (alreadyShown && tallPopupSignup) {
    tallPopupSignup.classList.remove("hidden");
  } else {
    setTimeout(function() {
      openPopup('Rcq94G', 'tallPopupShown', true);
      if (tallPopupSignup) tallPopupSignup.classList.remove("hidden");
    }, 10000);
  }

  if (tallPopupSignup) {
    tallPopupSignup.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('Rcq94G', 'tallPopupShown', false);
    });
  }

} else if (productHandle.includes('petite')) {
  let petitePopupSignupDesktop = document.querySelector('.vertical-popup-signup--petite-desktop');
  let petitePopupSignupMobile = document.querySelector('.vertical-popup-signup--petite-mobile');

  let alreadyShown = sessionStorage.getItem('petitePopupShown') === 'true';

  if (alreadyShown) {
    if (petitePopupSignupMobile) petitePopupSignupMobile.classList.remove("hidden");
    if (petitePopupSignupDesktop) petitePopupSignupDesktop.classList.remove("hidden");
  } else {
    setTimeout(function() {
      if (window.innerWidth < 749) {
        openPopup('RGFxX9', 'petitePopupShown', true);
      } else {
        openPopup('V34hTz', 'petitePopupShown', true);
      }
      if (petitePopupSignupMobile) petitePopupSignupMobile.classList.remove("hidden");
      if (petitePopupSignupDesktop) petitePopupSignupDesktop.classList.remove("hidden");
    }, 10000);
  }

  if (petitePopupSignupDesktop) {
    petitePopupSignupDesktop.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('V34hTz', 'petitePopupShown', false);
    });
  }

  if (petitePopupSignupMobile) {
    petitePopupSignupMobile.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('RGFxX9', 'petitePopupShown', false);
    });
  }
}

function openPopup(popupId = 'Rcq94G', sessionKey = null, checkSession = true) {
  if (checkSession && sessionKey && sessionStorage.getItem(sessionKey) === 'true') {
    return;
  }

  if (window._klOnsite && typeof window._klOnsite.push === 'function') {
    setTimeout(() => {
      window._klOnsite.push(['openForm', popupId]);
      if (sessionKey) sessionStorage.setItem(sessionKey, 'true');
    }, 200);
  } else {
    console.warn('Klaviyo not ready yet — retrying...');
    setTimeout(() => openPopup(popupId, sessionKey, checkSession), 500);
  }
}

// ===================== Petite Redirect ======================== //
// Fix pdp-save-badge on initial load using the actually selected variant
document.addEventListener('DOMContentLoaded', function() {
  const variantRadios = document.querySelector(
    '.product-form:not(.product-form--bundle-builder) variant-radios'
  );
  if (variantRadios) {
    requestAnimationFrame(() => {
      variantRadios.getSelectedOptions();
      variantRadios.getSelectedVariant();
      const cv = variantRadios.currentVariant;
      if (!cv) return;
      if (cv.compare_at_price > cv.price) {
        const saveAmount = cv.compare_at_price - cv.price;
        showPdpSaveBadge(saveAmount);
      } else if (!showPackPillBadgeIfAvailable()) {
        hidePdpSaveBadge();
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const targetElement = document.querySelector('.hide-mobile.klaviyo-btn.klaviyo-btn--petite-desktop');
  
  if (targetElement) {
    targetElement.addEventListener('click', function(event) {
      event.preventDefault();
      window.location.href = '/collections/womens-petite';
    });
  }
});


// ==================== Recently viewed products (cookie only) ====================
// Cookie holds up to MAX_ITEMS product handles (order: oldest → newest), each matching
// one `.recently-viewed-product-card` / Section Rendering fetch for that handle.

(function () {
  const COOKIE_NAME = 'recently_viewed_products';
  const MAX_ITEMS = 5;
  const COOKIE_MAX_AGE_DAYS = 365;

  function readHandleList() {
    const raw = typeof getCookie === 'function' ? getCookie(COOKIE_NAME) : '';
    if (!raw) return [];
    try {
      const parsed = JSON.parse(decodeURIComponent(raw));
      return Array.isArray(parsed)
        ? parsed.filter(function (h) {
            return typeof h === 'string' && h.length;
          })
        : [];
    } catch (e) {
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed)
          ? parsed.filter(function (h) {
              return typeof h === 'string' && h.length;
            })
          : [];
      } catch (e2) {
        return [];
      }
    }
  }

  function writeHandleList(handles) {
    if (typeof setCookie !== 'function') return;
    const trimmed = handles.slice(-MAX_ITEMS);
    setCookie(COOKIE_NAME, encodeURIComponent(JSON.stringify(trimmed)), COOKIE_MAX_AGE_DAYS);
  }

  function setRecentlyViewedPdp() {
    const card = document.querySelector('.main-product');
    if (!card) return;
    const handle = card.getAttribute('data-handle');
    if (!handle) return;

    let list = readHandleList();
    list = list.filter(function (h) {
      return h !== handle;
    });
    list.push(handle);
    while (list.length > MAX_ITEMS) {
      list.shift();
    }
    writeHandleList(list);
  }

  setRecentlyViewedPdp();
})();
 
